/* ============================================================
   FAD THEME v2 , theme.js
   Cart drawer, gallery, variants, ticker, quantity
   ============================================================ */
(function(){
'use strict';

/* ---- SHOW/HIDE HELPERS (immune to CSS specificity conflicts) ---- */
function showEl(el){if(el){el.style.display='';el.removeAttribute('hidden');}}
function hideEl(el){if(el){el.style.display='none';el.setAttribute('hidden','');}}

/* ---- UTILS ---- */
function qs(s,c){return(c||document).querySelector(s);}
function qsa(s,c){return Array.from((c||document).querySelectorAll(s));}
function on(el,ev,fn){if(el)el.addEventListener(ev,fn);}
function nowMs(){return (window.performance&&performance.now)?performance.now():Date.now();}
function formatMoney(cents){
  var fmt=(window.theme&&window.theme.moneyFormat)||'${{amount}}';
  cents=parseInt(cents,10)||0;
  var value=cents/100;
  function withSep(num,thousands,decimal,decimals){
    decimals=decimals==null?2:decimals;
    var parts=Math.abs(num).toFixed(decimals).split('.');
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,thousands);
    var out=parts.join(decimals>0?decimal:'');
    return num<0?'-'+out:out;
  }
  return fmt
    .replace(/\{\{\s*amount\s*\}\}/g,withSep(value,',','.',2))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,withSep(value,',','.',0))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,withSep(value,'.',',',2))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,withSep(value,'.',',',0))
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g,withSep(value,' ',',',2))
    .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,withSep(value,"'",'.',2))
    .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g,withSep(value,' ',',',0));
}

/* ---- ESCAPE (v5.30: JS-rendered cart HTML must escape data) ---- */
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

/* ---- CART REQUEST QUEUE (v5.30) ----
   All cart mutations are serialised through one promise chain and keyed by
   the Shopify line item KEY, never the line number. Line numbers go stale
   the moment any app (Bundler, cartbot) rewrites the cart, which corrupted
   carts when buttons were clicked quickly. The change.js response already
   contains the full cart, so we render from it instead of refetching. */
var cartBusy=false;
var cartQueue=Promise.resolve();
function queueCartOp(op){
  cartQueue=cartQueue.then(op,op);
  return cartQueue;
}
function cartChangeByKey(key,qty){
  return fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})
  }).then(function(r){
    if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Cart update failed');});
    return r.json();
  });
}

/* ---- BUNDLER RECONCILIATION (v5.36) ----
   Bundler (device bundles) reprices cart lines a few seconds after a cart
   change. Adaptive polling: after any mutation, poll /cart.js roughly every
   second, re-render on change, stop once stable (max ~9.5s).
   v5.36: core multi-pack deal removed by merchant - all core-pack helper
   text and the pending-discount indicator removed with it. */
var reconcileTimers=[];
function cartStateSig(c){
  return c.total_price+':'+c.items.map(function(i){return i.key+'x'+i.quantity+'@'+i.final_price;}).join(',');
}
function scheduleCartReconcile(render){
  reconcileTimers.forEach(clearTimeout);
  reconcileTimers=[];
  var last=null,stable=0;
  var delays=[900,1800,2800,4000,5400,7200,9500];
  delays.forEach(function(d){
    reconcileTimers.push(setTimeout(function(){
      fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){return fadMaybeUpgradeQWF(c);})
      .then(function(c){
        var sig=cartStateSig(c);
        if(sig!==last){last=sig;stable=0;render(c);}
        else{stable++;}
        if(stable>=2){
          reconcileTimers.forEach(clearTimeout);
          reconcileTimers=[];
        }
      })
      .catch(function(){});
    },d));
  });
}

/* ---- v6.18: KACHING KIT OFFER RECONCILER ----------------------------
   Replaces the v5.54 Upgrade With A Mate upgrade. Same goal, different and
   far safer mechanism, and it now covers three faults the old one could not.

   WHAT WAS WRONG

   1. A kit added from a collection tile, a related-products card, or search
      arrived with no Kaching stamp at all and was charged full RRP. Verified
      live: an unstamped Walnut kit is $129.00, the same kit stamped "Get The
      Kit" is $109.00. Every quick-add was quietly costing $20.
   2. The upgrade to Upgrade With A Mate removed both kit lines and re-added
      them as a stamped pair. That is destructive, so it had to refuse any
      cart holding anything other than kits, it flashed an empty cart, it
      needed a restore path, and a single failure armed a 60 second backoff.
   3. Removing one kit from a QWF pair left the survivor at full price
      whenever the line removed was the MAIN one. The partner line carries no
      bid, so nothing matched it. Verified live: $119.00 instead of $99.00.

   WHAT THIS DOES INSTEAD

   /cart/change.js accepts a `properties` object and Kaching honours it, so a
   line can be stamped IN PLACE. Nothing is ever removed, so the cart cannot
   be lost, Cores can sit alongside kits, and there is no empty window to
   paint around.

   MEASURED ON THE LIVE STORE (Walnut $129, Steel $119)

     2 kits, unstamped                        $248.00
     2 kits, each stamped Get The Kit         $208.00
     2 kits, stamped as a QWF pair            $188.00   <- target
     1 kit, unstamped                         $129.00
     1 kit, stamped Get The Kit               $109.00   <- target

   STAMP SHAPES, captured from Kaching's own widget and verified by cart total

     single   {deal, pp:<product id>, main:true, v, bid:'Gzdf'}
     pair     main    {deal, pp, main:true, v, id:<offer>, bid:'s-Sz'}
              partner {id:<offer>, deal, v, collectionBreaksProduct:true}

   `v` is Kaching's deal block version id. It is NOT validated: a random uuid
   and an omitted uuid both discount correctly. The old code refused to run
   without one, which is why a shopper who never opened a kit product page
   never got the upgrade. A real one is still preferred when we have it.

   A kit LINE must be quantity 1. A single line of quantity 2 takes no
   discount under either offer, verified. Splitting is left alone here: it is
   a rarer cart and the safety check below would only roll it back. */
var FAD_KIT={
  deal:'PSpq',
  offerId:'yE6a',
  single:'Gzdf',
  pair:'s-Sz',
  kitHandles:['fad-wood-inhaler','fad-steel-inhaler']
};
var FAD_KIT_ENABLED=true;
window.fadKitDisable=function(){FAD_KIT_ENABLED=false;return 'FAD kit reconciler disabled for this page';};
var kitBusy=false;

function kitStamp(item){
  try{return JSON.parse((item.properties||{}).__kaching_bundles);}catch(e){return null;}
}
function kitIsKit(item){return FAD_KIT.kitHandles.indexOf(item.handle)>=0;}
function kitInstance(items){
  for(var i=0;i<items.length;i++){var s=kitStamp(items[i]);if(s&&s.v)return s.v;}
  try{var ls=localStorage.getItem('fadQwfV');if(ls)return ls;}catch(e){}
  /* not validated by Kaching, so a minted one is as good as a real one */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
    var r=Math.random()*16|0;return (c==='x'?r:(r&0x3|0x8)).toString(16);});
}
function qwfStashInstance(){
  try{
    var el=document.querySelector('#fad-product-form [name="properties[__kaching_bundles]"]');
    if(!el)return;
    var v=JSON.parse(el.value).v;
    if(v)localStorage.setItem('fadQwfV',v);
  }catch(e){}
}
/* v6.19: TWO OF THE SAME KIT ARRIVE AS ONE LINE.
   Shopify merges two adds of the same variant with the same properties into a
   single line of quantity 2, and a kit line of quantity 2 takes no offer under
   either bar. Measured: two Walnut kits added one at a time sat at $258.00 and
   stayed there, because v6.18 saw quantity 2 and refused to touch it.

   A quantity 2 line cannot be stamped into a pair, it has to become two lines.
   The order matters: the partner unit is ADDED first, so the cart briefly holds
   three units and never fewer than the customer put in it, and only then is the
   fat line converted down to a single main-stamped unit. Verified live:
     $258.00 -> add partner -> $387.00 (3 units) -> convert -> $198.00

   The plan is a list of operations rather than a map of stamps, because that
   split needs an add as well as a write. */
function kitPlan(cart){
  if(!FAD_KIT_ENABLED||!cart||!cart.items||!cart.items.length)return null;
  var kits=cart.items.filter(kitIsKit);
  if(!kits.length)return null;
  var units=0;
  kits.forEach(function(i){units+=i.quantity||1;});
  var v=kitInstance(cart.items);
  var ops=[];

  if(units===1){
    var one=kits[0];
    var want={deal:FAD_KIT.deal,pp:one.product_id,main:true,v:v,bid:FAD_KIT.single};
    if(!kitStampMatches(one,want))ops.push({op:'stamp',key:one.key,stamp:want});
    return ops.length?ops:null;
  }

  if(units===2){
    if(kits.length===2){
      var mainWant={deal:FAD_KIT.deal,pp:kits[0].product_id,main:true,v:v,id:FAD_KIT.offerId,bid:FAD_KIT.pair};
      var partWant={id:FAD_KIT.offerId,deal:FAD_KIT.deal,v:v,collectionBreaksProduct:true};
      /* already a valid pair either way round: leave it be */
      if((kitStampMatches(kits[0],mainWant)&&kitStampMatches(kits[1],partWant))||
         (kitStampMatches(kits[1],mainWant)&&kitStampMatches(kits[0],partWant)))return null;
      ops.push({op:'stamp',key:kits[0].key,stamp:mainWant});
      ops.push({op:'stamp',key:kits[1].key,stamp:partWant});
      return ops;
    }
    /* one line, quantity 2: split it */
    var fat=kits[0];
    if(!fat.variant_id)return null;
    ops.push({op:'add',variantId:fat.variant_id,stamp:{id:FAD_KIT.offerId,deal:FAD_KIT.deal,v:v,collectionBreaksProduct:true}});
    ops.push({op:'stamp',key:fat.key,quantity:1,
      stamp:{deal:FAD_KIT.deal,pp:fat.product_id,main:true,v:v,id:FAD_KIT.offerId,bid:FAD_KIT.pair}});
    return ops;
  }

  /* three or more units: no bar covers it as a set, so give every line that can
     take the single-kit offer its stamp and leave quantities alone */
  kits.forEach(function(i){
    if((i.quantity||1)!==1)return;
    var w={deal:FAD_KIT.deal,pp:i.product_id,main:true,v:v,bid:FAD_KIT.single};
    if(!kitStampMatches(i,w))ops.push({op:'stamp',key:i.key,stamp:w});
  });
  return ops.length?ops:null;
}
/* Compares intent, not bytes: `v` is free-form and the key order out of
   JSON.parse is not guaranteed, so two stamps that would price identically
   must not look different or the reconciler would rewrite them forever. */
function kitStampMatches(item,target){
  var cur=kitStamp(item);
  if(!cur||!target)return !cur&&!target;
  if(!!cur.main!==!!target.main)return false;
  if(!!cur.collectionBreaksProduct!==!!target.collectionBreaksProduct)return false;
  if((cur.bid||'')!==(target.bid||''))return false;
  if((cur.deal||'')!==(target.deal||''))return false;
  return true;
}
function kitNeedsWork(cart){return kitPlan(cart);}
function kitPending(cart){return !!kitPlan(cart);}

/* ---- v6.20: PRICE THE OFFER BEFORE THE SERVER DOES ----------------------
   The reconciler needs two round trips to Shopify, and until they land the
   cart really does hold the undiscounted total. Painting that number and
   correcting it a second later is the jump. Painting "Applying bundle
   price..." instead, which is what v5.57 did, is the same problem wearing a
   politer hat: the customer still sees no price, then a price.

   The discount is deterministic, so it does not need to be waited for. Both
   bars are flat amounts off each kit unit, so the final line price is known
   the moment the plan is known, and the drawer can paint it immediately. The
   server confirms it a moment later and nothing moves.

   MIRRORED FROM THE KACHING DEAL, in cents off ONE kit unit. Read out of the
   live deal config for PSpq: Get The Kit is $20, Upgrade With A Mate is $30.
   Change the deal in Kaching and these must change with it. Wrong values here
   cost nothing but a brief flicker: the real price still lands and wins. */
/* v6.26: the kit bars changed from flat amounts to PERCENTAGES. Read from the
   live deal config for PSpq: Get The Kit 10%, Upgrade With A Mate 20%.

   Kaching does not simply take the percentage off each line. It discounts the
   kit SUBTOTAL, rounds that to a charm price, and then allocates the result
   back across the kit lines. Measured live, three independent points:

     1 Walnut   $129.00 x 0.90 = $116.10  ->  charged $116.99
     1 Steel    $119.00 x 0.90 = $107.10  ->  charged $107.99
     pair       $248.00 x 0.80 = $198.40  ->  charged $198.99

   so the rule is: drop the cents, then add 99. The same rule reproduces the
   Core tiers below ($59.94 x 0.65 = $38.96 -> $38.99, $119.88 x 0.55 = $65.93
   -> $65.99), which is why those two numbers have always been right.

   A Core in the cart is untouched by this: verified that a pair plus a Core
   priced the kits at $198.99 and left the Core at $9.99, so the charm applies
   to the kit subtotal alone, not the cart. */
FAD_KIT.percent={};
FAD_KIT.percent[FAD_KIT.single]=10;
FAD_KIT.percent[FAD_KIT.pair]=20;
function kitCharm(cents){
  if(!(cents>0))return 0;
  return Math.floor(cents/100)*100+99;
}
/* Percentage off the kit subtotal, given the whole cart. Only the two states
   measured above are previewed. Three or more kits take the single-kit bar per
   line and its rounding is unverified, so nothing is promised for that cart. */
function kitOfferPercentFor(cart){
  var kits=(cart&&cart.items||[]).filter(kitIsKit);
  if(!kits.length)return 0;
  var units=0;
  kits.forEach(function(i){units+=i.quantity||1;});
  if(units===2)return FAD_KIT.percent[FAD_KIT.pair]||0;
  if(units===1)return FAD_KIT.percent[FAD_KIT.single]||0;
  return 0;
}
/* Extra discount, per line key, that the cart is about to receive but has not
   been given yet. Zero for anything already priced correctly, so a settled
   cart produces an empty map and the preview disappears of its own accord. */
function kitPreviewDeltas(cart){
  var out={total:0,perKey:{}};
  if(!cart||!cart.items)return out;
  /* v6.20b: the preview must also cover the gap AFTER the stamp is written and
     BEFORE Kaching prices it. Basing it only on "a plan is pending" handed the
     drawer back the undiscounted total for that second, which is the same jump
     one step later. A line qualifies while a plan is pending, or once it
     carries a stamp for this deal and is still sitting above the offer price.
     A line with neither gets nothing promised on its behalf. */
  var pending=kitPending(cart);
  var pct=kitOfferPercentFor(cart);
  if(!pct)return out;

  /* v6.26: the offer prices the kit SUBTOTAL, not each line, so the target is
     computed once and then shared out. Kits only: a Core in the cart is not
     part of this calculation and must not be discounted by it. */
  var kits=[],rrp=0,now=0;
  cart.items.forEach(function(i){
    if(!kitIsKit(i))return;
    var st=kitStamp(i);
    if(!(pending||(st&&st.deal===FAD_KIT.deal)))return;
    var q=i.quantity||1;
    var unit=(typeof i.original_price==='number'&&i.original_price>0)?i.original_price:(i.final_price||0);
    kits.push({key:i.key,rrp:unit*q,now:i.final_line_price||0});
    rrp+=unit*q; now+=i.final_line_price||0;
  });
  if(!kits.length||!(rrp>0))return out;

  var target=kitCharm(Math.round(rrp*(100-pct)/100));
  if(!(target>0)||target>=now)return out;

  /* share the target across the kit lines in proportion to their RRP, with the
     rounding remainder landing on the dearest line, so the parts always sum to
     the total the customer is about to be charged */
  var saved=now-target,handed=0,biggest=null,biggestVal=-1;
  kits.forEach(function(k){
    var share=Math.floor(saved*k.rrp/rrp);
    out.perKey[k.key]=share; handed+=share;
    if(k.rrp>biggestVal){biggestVal=k.rrp;biggest=k.key;}
  });
  if(biggest!=null)out.perKey[biggest]+=(saved-handed);
  out.total=saved;
  return out;
}
/* ---- v6.27: FREE SHIPPING AS A VISIBLE SAVING --------------------------
   The store gives free standard shipping over the threshold and nothing in the
   cart said so, which throws away the one benefit the customer has already
   earned by the time they are looking at the total.

   Rates measured live on 05 Sep 2026 against a Sunshine Coast address:
     under the threshold   Standard $5.99   Express $9.99
     over  the threshold   Free Standard Shipping $0.00   Express $9.99

   The saving is the STANDARD rate, $5.99. Express is not the comparison: it is
   a paid upgrade that costs $9.99 either way, so striking $9.99 through would
   overstate what free shipping is worth. The figure comes from a theme setting
   so it tracks Settings > Shipping rather than being buried here. */
/* v6.29: the two standard shipping rates, kept here rather than in theme
   settings so the cart works out of the box with nothing to configure.

   The rate depends on WHAT is in the cart, not just the total. A device ships
   at a higher standard rate than Cores do, so a kit order saves more than a
   Cores order and one figure for both understates the kit.

     Cores    $5.99   measured live, a 4-pack cart quotes Standard $5.99
     Devices  $9.99   merchant-stated

   The device rate cannot be read back from the storefront: the cheapest kit is
   $107.99, so every kit cart already qualifies for the free rate and the API
   only ever returns $0.00 for it.

   IF THE RATES CHANGE IN SETTINGS > SHIPPING, CHANGE THEM HERE. This is the
   only place in the theme they are written, and the cart page mirrors it. */
var FAD_SHIP={cores:599,devices:999};
window.FAD_SHIP=FAD_SHIP;
function shipCost(cart){
  var kit=!!(cart&&cart.items&&cart.items.some(kitIsKit));
  return kit?FAD_SHIP.devices:FAD_SHIP.cores;
}
function shipThreshold(){
  var t=(window.theme&&window.theme.freeShipThreshold);
  return (typeof t==='number'&&t>0)?t:6000;
}
/* Judged on what the customer will actually pay, so a cart that only clears the
   threshold before its bundle discount does not promise free shipping it will
   not get. */
function shipStateFor(netTotal,cart){
  var cost=shipCost(cart);
  return {free:netTotal>=shipThreshold(),cost:cost,remaining:Math.max(0,shipThreshold()-netTotal)};
}
/* Two plain kit lines do not share a bundle signal yet, so they would render
   as two loose items and then collapse into one bundle block a second later.
   Grouping them up front removes that second reflow. */
function kitPendingPairKeys(cart){
  var plan=kitPlan(cart);
  if(!plan)return null;
  var stamps=plan.filter(function(o){return o.op==='stamp';});
  var isPair=stamps.some(function(o){return o.stamp&&o.stamp.bid===FAD_KIT.pair;});
  if(!isPair)return null;
  var kits=(cart.items||[]).filter(kitIsKit);
  if(kits.length!==2)return null;
  return kits.map(function(i){return i.key;});
}

function kitWriteStamp(key,stamp){
  return fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json',Accept:'application/json'},
    body:JSON.stringify({id:key,quantity:1,properties:{__kaching_bundles:JSON.stringify(stamp)}})
  }).then(function(r){
    if(!r.ok)throw new Error('kit: stamp rejected');
    return r.json();
  });
}
function kitAddUnit(variantId,stamp){
  var b=new URLSearchParams();
  b.append('items[0][id]',String(variantId));
  b.append('items[0][quantity]','1');
  b.append('items[0][properties][__kaching_bundles]',JSON.stringify(stamp));
  return fetch('/cart/add.js',{
    method:'POST',
    headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
    body:b
  }).then(function(r){
    if(!r.ok)throw new Error('kit: partner add rejected');
    return r.json();
  });
}
function kitRunOp(step){
  return (step.op==='add')?kitAddUnit(step.variantId,step.stamp):kitWriteStamp(step.key,step.stamp);
}
/* Poll for the repricing rather than sleeping a flat interval. It normally
   lands inside a few hundred milliseconds. */
function kitAwaitPrice(target,tries,gap){
  return fetch('/cart.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){
      if(c.total_price<=target||tries<=1)return c;
      return new Promise(function(res){setTimeout(res,gap);})
        .then(function(){return kitAwaitPrice(target,tries-1,gap);});
    });
}

/* Resolves to the reconciled cart, or to the cart it was handed, untouched.
   Never throws, never leaves the customer worse off: if the total did not
   fall, the original stamps are put back. */
function fadReconcileKits(cart){
  if(kitBusy)return Promise.resolve(cart);
  var todo=kitNeedsWork(cart);
  if(!todo)return Promise.resolve(cart);

  kitBusy=true;
  var before=cart.total_price;
  var beforeKeys={};
  var prior=[];
  cart.items.forEach(function(i){
    beforeKeys[i.key]=true;
    /* v6.19: the undo used to write quantity 1 to every line it restored,
       which would have silently reset a Core line of quantity 3. Carry each
       line's real quantity. */
    prior.push({key:i.key,qty:i.quantity||1,stamp:(i.properties||{}).__kaching_bundles||null});
  });
  /* v6.19: a split adds a unit before it converts the fat line. If the run
     then fails or does not pay, that extra unit has to go, or the customer is
     left holding three kits. It is identified as a partner-stamped kit line
     that was not in the cart when we started. */
  function kitDropSurplus(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){
        var surplus=c.items.filter(function(i){
          if(beforeKeys[i.key]||!kitIsKit(i))return false;
          var st=kitStamp(i);
          return !!(st&&st.collectionBreaksProduct);
        });
        var chain=Promise.resolve();
        surplus.forEach(function(i){
          chain=chain.then(function(){
            return fetch('/cart/change.js',{
              method:'POST',
              headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({id:i.key,quantity:0})}).catch(function(){});
          });
        });
        return chain;
      }).catch(function(){});
  }

  var chain=Promise.resolve();
  todo.forEach(function(step){
    chain=chain.then(function(){return kitRunOp(step);});
  });
  return chain
    .then(function(){return kitAwaitPrice(before-1,8,120);})
    .then(function(c2){
      kitBusy=false;
      if(window.fadATCDebug)console.log('[FAD kit]',before,'->',c2.total_price);
      if(c2.total_price<=before)return c2;
      /* worse than before: undo. Any unit this run added goes first, then the
         original stamps and quantities go back on. */
      var undo=kitDropSurplus();
      prior.forEach(function(p){
        undo=undo.then(function(){
          return fetch('/cart/change.js',{
            method:'POST',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:p.key,quantity:p.qty,properties:p.stamp?{__kaching_bundles:p.stamp}:{}})
          }).catch(function(){});
        });
      });
      return undo.then(function(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});});
    })
    .catch(function(err){
      if(window.fadATCDebug)console.log('[FAD kit] failed:',err&&err.message);
      return kitDropSurplus().then(function(){
        kitBusy=false;
        return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});
      }).catch(function(){kitBusy=false;return cart;});
    });
}
window.fadReconcileKits=fadReconcileKits;
/* exposed for sections/cart-main-fum.liquid, which keeps its own renderer */
window.fadKitPreviewDeltas=function(c){return kitPreviewDeltas(c);};
window.fadKitPendingPairKeys=function(c){return kitPendingPairKeys(c);};
/* Kept under the old names: sections/cart-main-fum.liquid calls these. */
var fadMaybeUpgradeQWF=fadReconcileKits;
window.fadMaybeUpgradeQWF=fadReconcileKits;
/* Nothing is removed any more, so the cart is never momentarily empty. These
   stay so the renderers can avoid painting a price that is about to change. */
window.fadQwfInFlight=function(){return kitBusy;};
window.fadQwfPending=function(c){return kitPending(c);};
function qwfPending(c){return kitPending(c);}

/* ---- v5.54: BUY BOX BUTTONS INSIDE THE BUNDLE WIDGET ---------------
   Requested placement: Add to Cart and Buy Now directly beneath the
   Upgrade With A Mate tile and above the "You're saving ..." summary.

   v5.42 reordered the buy box with flex `order` precisely to avoid DOM
   moves, because Kaching re-renders its own subtree. That still holds for
   siblings, but the target position is INSIDE Kaching's block, and `order`
   cannot move a node between flex containers. So the buttons are relocated
   once and re-asserted by a MutationObserver: the wrapper is kept in a
   closure, so when Kaching wipes its subtree the same node (buttons and
   all) is simply re-appended rather than rebuilt. Position within the
   block is still `order`, set in theme.css. */
function initBuyBoxInline(){
  var atc=document.getElementById('atc-btn');
  if(!atc)return;
  var bn=document.getElementById('buy-now-btn');
  var slot=document.querySelector('.fad-bundle-slot');
  if(!slot)return;
  var form=document.getElementById('fad-product-form');
  if(!form)return;
  var wrap=document.createElement('div');
  wrap.className='fad-buybox-inline';
  /* Grouptify injects .mpg-swatch immediately before whatever it finds as the
     ATC button, so moving the button dragged the variant picker into the
     bundle widget with it. Evict it back to the form on every pass; the
     existing `#fad-product-form .mpg-swatch{order:1}` rule then puts it back
     above the bundle block where it belongs. */
  function evictSwatches(){
    var moved=false;
    qsa('.mpg-swatch',slot).forEach(function(sw){
      form.appendChild(sw);moved=true;
    });
    return moved;
  }
  function place(){
    var blk=slot.querySelector('.kaching-bundles__block');
    if(!blk)return;
    if(atc.parentElement!==wrap)wrap.appendChild(atc);
    if(bn&&bn.parentElement!==wrap)wrap.appendChild(bn);
    if(wrap.parentElement!==blk)blk.appendChild(wrap);
    evictSwatches();
  }
  place();
  if(window.MutationObserver){
    var t=null;
    new MutationObserver(function(){clearTimeout(t);t=setTimeout(place,60);})
      .observe(slot,{childList:true,subtree:true});
  }
}

/* ---- HEADER MOBILE NAV ---- */
function initNav(){
  /* ── Mobile hamburger ─────────────────────── */
  var btn=qs('#menu-toggle');
  var nav=qs('#mobile-nav');
  if(btn&&nav){
    on(btn,'click',function(){
      var open=btn.classList.toggle('is-open');
      nav.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',String(open));
      nav.setAttribute('aria-hidden',String(!open));
    });
  }

  /* ── Desktop dropdown: click-toggled ─────── */
  /* CSS-only hover breaks on sticky headers due to stacking context.
     Fix: toggle .is-open class on click, close on outside click / Escape. */
  var dropdownParents=qsa('.has-dropdown');
  dropdownParents.forEach(function(parent){
    var trigger=parent.querySelector('.header__nav-btn');
    if(!trigger)return;
    on(trigger,'click',function(e){
      e.stopPropagation();
      var isOpen=parent.classList.contains('is-open');
      /* close all others */
      dropdownParents.forEach(function(p){
        p.classList.remove('is-open');
        var t=p.querySelector('.header__nav-btn');
        if(t)t.setAttribute('aria-expanded','false');
      });
      if(!isOpen){
        parent.classList.add('is-open');
        trigger.setAttribute('aria-expanded','true');
      }
    });
  });

  /* Close dropdowns on outside click */
  document.addEventListener('click',function(){
    dropdownParents.forEach(function(p){
      p.classList.remove('is-open');
      var t=p.querySelector('.header__nav-btn');
      if(t)t.setAttribute('aria-expanded','false');
    });
  });

  /* Close on Escape */
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      dropdownParents.forEach(function(p){
        p.classList.remove('is-open');
        var t=p.querySelector('.header__nav-btn');
        if(t)t.setAttribute('aria-expanded','false');
      });
    }
  });

  /* ── Mobile accordion sub-menus ─────────── */
  qsa('.header__mobile-parent-btn').forEach(function(parentBtn){
    on(parentBtn,'click',function(){
      var sub=parentBtn.nextElementSibling;
      if(!sub)return;
      var isOpen=parentBtn.getAttribute('aria-expanded')==='true';
      parentBtn.setAttribute('aria-expanded',String(!isOpen));
      if(isOpen){hideEl(sub);}else{showEl(sub);}
    });
  });
}


/* ---- RRP / COMPARE-AT (v5.40) ---------------------------------------
   /cart.js does not reliably expose compare_at_price, so the layout renders
   a variantId -> compare_at map into window.theme.compareAt. The struck
   price is the higher of the RRP and the pre-discount line price. */
function lineWasOf(item){
  var map=(window.theme&&window.theme.compareAt)||{};
  var rrp=parseInt(map[item.variant_id],10)||0;
  if(typeof item.compare_at_price==='number'&&item.compare_at_price>rrp)rrp=item.compare_at_price;
  var unit=Math.max(rrp,item.original_price||item.final_price||0);
  var line=unit*item.quantity;
  var orig=(typeof item.original_line_price==='number')?item.original_line_price:item.final_line_price;
  return Math.max(line,orig);
}
function cartWasTotal(cart){
  var t=0;
  cart.items.forEach(function(i){t+=lineWasOf(i);});
  var orig=(typeof cart.original_total_price==='number')?cart.original_total_price:cart.total_price;
  return Math.max(t,orig);
}

/* ---- ORDER-LEVEL DISCOUNT ALLOCATION (v5.45) ------------------------
   Shopify has two kinds of discount and /cart.js reports them very
   differently.

   LINE level (a discount Function that targets specific lines): the
   reduction is already baked into item.final_line_price. Nothing to do.

   ORDER level (an automatic cart discount, which is what Kaching applies
   for a bundle): the line prices stay at full RRP and only
   cart.total_price drops. That is why the drawer showed every item at its
   original price while the total was correct. It was not a bug in the
   arithmetic, it was reading a field Shopify never discounts.

   Fix: derive the order-level residual and spread it across the lines the
   same way checkout does, proportionally to line value. The largest line
   absorbs the rounding remainder so the parts always sum to the total
   exactly, with no cent drifting loose. Display only, nothing is sent to
   Shopify. */
var orderAlloc={};
function setOrderAlloc(cart){
  orderAlloc={};
  if(!cart||!cart.items||!cart.items.length)return orderAlloc;
  var lineSum=0;
  cart.items.forEach(function(i){lineSum+=(i.final_line_price||0);});
  var subtotal=(typeof cart.items_subtotal_price==='number')?cart.items_subtotal_price:lineSum;
  var residual=subtotal-(cart.total_price||0);
  if(!(residual>0)||!(lineSum>0))return orderAlloc;
  if(residual>lineSum)residual=lineSum;
  var handed=0,biggest=null,biggestVal=-1;
  cart.items.forEach(function(i){
    var share=Math.floor(residual*(i.final_line_price||0)/lineSum);
    orderAlloc[i.key]=share;
    handed+=share;
    if((i.final_line_price||0)>biggestVal){biggestVal=i.final_line_price||0;biggest=i.key;}
  });
  if(biggest!=null)orderAlloc[biggest]+=(residual-handed);
  return orderAlloc;
}
/* v6.20: netLineOf already subtracts orderAlloc from every line, so folding the
   pending offer in here prices the whole drawer, the bundle block and the
   totals from one place rather than threading a preview through each. */
function applyKitPreview(cart){
  var pv=kitPreviewDeltas(cart);
  for(var k in pv.perKey){
    if(Object.prototype.hasOwnProperty.call(pv.perKey,k))orderAlloc[k]=(orderAlloc[k]||0)+pv.perKey[k];
  }
  return pv.total;
}
/* What the customer actually pays for this line, order discounts included. */
function netLineOf(item){
  var net=(item.final_line_price||0)-(orderAlloc[item.key]||0);
  return net>0?net:0;
}
function netUnitOf(item){
  var q=item.quantity||1;
  return Math.round(netLineOf(item)/q);
}

/* ---- BUNDLE GROUPING (v5.40) ----------------------------------------
   Bundle apps (Kaching, and most others) add each bundle component as its
   own cart line, tagged with a shared line item property. We group those
   lines back into one bundle card so the customer sees what they bought,
   not seven unrelated rows. Detection is deliberately broad: known keys
   first, then any property whose name mentions "bundle". No app-specific
   coupling, so it keeps working if the app changes or is replaced. */
var BUNDLE_KEY_RE=/bundle|kaching|bndl|combo|pack_?id|kit_?id/i;
var BUNDLE_IGNORE_RE=/index|position|line_?no|item_?no|sort|order|qty|quantity|count|seq|step|slot|row/i;
var BUNDLE_NAME_KEYS=['_bundle_name','_kaching_bundle_name','_bundle_title','_kaching_bundle_title','_bundle_label','Bundle','_bundle'];
function bundleIsIdish(v){return /^[0-9a-f-]{8,}$/i.test(v)||/^[a-z]{0,3}[_-]?\d{3,}$/i.test(v);}
function bundleUsableValue(v){
  if(v===null||v===undefined)return null;
  var s=String(v).trim();
  if(!s||s.length<3)return null;
  if(/^(true|false|yes|no)$/i.test(s))return null;
  return s.toLowerCase();
}
/* Signals that two cart lines belong to the same bundle, strongest first.
   1. a bundle-ish line item property they share
   2. the same line-level discount application (bundle apps that price via a
      Shopify Function leave no properties at all, only a shared discount)
   3. any private (_underscore) property value they share, used only when
      nothing above matched */
function bundleSignals(item){
  var strong=[],weak=[],p=item.properties||{};
  for(var key in p){
    if(!Object.prototype.hasOwnProperty.call(p,key))continue;
    if(BUNDLE_IGNORE_RE.test(key))continue;
    var v=bundleUsableValue(p[key]);
    if(!v)continue;
    if(BUNDLE_KEY_RE.test(key)){
      strong.push('p:'+key.replace(/^_+/,'').toLowerCase()+'::'+v);
      if(v.length>=4&&!/^\d{1,3}$/.test(v))strong.push('p:*::'+v);
    } else if(key.charAt(0)==='_'){
      if(v.length>=5)weak.push('w:'+v);
    }
  }
  var allocs=item.line_level_discount_allocations||item.discounts||[];
  for(var i=0;i<allocs.length;i++){
    var da=allocs[i].discount_application||allocs[i];
    var t=da&&(da.key||da.title);
    if(!t)continue;
    if(da.target_type&&da.target_type!=='line_item')continue;
    strong.push('d::'+String(t).trim().toLowerCase());
  }
  return {strong:strong,weak:weak};
}
/* ---- v6.16: bundle names come from Kaching's OFFER, not its deal ---------
   Kaching titles the line discount after the DEAL, so every offer inside deal
   PSpq reaches the cart labelled "Get the kit", including Upgrade With A Mate.
   The offer is identifiable: the main line's __kaching_bundles stamp carries
   the offer id in `bid`. Map the ids we ship to the names the customer was
   sold, and let that beat the discount title.

   A bid that is not listed falls through to the old behaviour, so an offer
   added in the Kaching admin still renders, just under its deal name. */
var FAD_BUNDLE_NAMES={
  's-Sz':'Upgrade With A Mate',
  'Gzdf':'Get The Kit',
  'L-1L':'6 Pack Bundle',
  'Zv7q':'12 Pack Bundle'
};
function bundleBidOf(item){
  try{
    var st=JSON.parse((item.properties||{}).__kaching_bundles);
    return (st&&st.bid)?String(st.bid):'';
  }catch(e){return '';}
}
/* Scans a whole group: only the MAIN line carries bid, the collection-break
   partners do not, so naming from items[0] alone would miss it. */
/* v6.18: a stamp can outlive the offer it names. Remove one kit from a pair
   and the survivor still carries bid s-Sz for the moment before the reconciler
   rewrites it, which would label a single kit "Upgrade With A Mate". Each name
   states how many units it needs, and a group that no longer has them falls
   through to the single-kit name. */
var FAD_BUNDLE_MIN_UNITS={'s-Sz':2,'L-1L':6,'Zv7q':12};
function bundleNameFromOffer(items){
  var units=0;
  items.forEach(function(i){units+=i.quantity||1;});
  for(var i=0;i<items.length;i++){
    var bid=bundleBidOf(items[i]);
    var n=FAD_BUNDLE_NAMES[bid];
    if(!n)continue;
    var need=FAD_BUNDLE_MIN_UNITS[bid]||1;
    if(units<need)return (bid==='s-Sz')?FAD_BUNDLE_NAMES['Gzdf']:'';
    return n;
  }
  return '';
}
function bundleNameOf(item){
  var p=item.properties||{};
  for(var i=0;i<BUNDLE_NAME_KEYS.length;i++){
    var v=p[BUNDLE_NAME_KEYS[i]];
    if(v&&!bundleIsIdish(String(v)))return String(v);
  }
  for(var key in p){
    if(!Object.prototype.hasOwnProperty.call(p,key))continue;
    if(/bundle.*(name|title|label)/i.test(key)&&p[key]&&!bundleIsIdish(String(p[key])))return String(p[key]);
  }
  var allocs=item.line_level_discount_allocations||item.discounts||[];
  for(var j=0;j<allocs.length;j++){
    var da=allocs[j].discount_application||allocs[j];
    if(da&&da.title&&!bundleIsIdish(String(da.title)))return String(da.title);
  }
  return 'Bundle';
}
function groupCartItems(items){
  var parent=[],sigs=[];
  function find(x){while(parent[x]!==x){parent[x]=parent[parent[x]];x=parent[x];}return x;}
  function union(a,b){a=find(a);b=find(b);if(a!==b)parent[b]=a;}
  items.forEach(function(it,i){parent[i]=i;sigs[i]=bundleSignals(it);});

  var seen={};
  sigs.forEach(function(sg,i){
    sg.strong.forEach(function(v){
      if(seen[v]==null)seen[v]=i;else union(seen[v],i);
    });
  });
  /* v6.20: two plain kit lines carry no shared signal until the reconciler
     stamps them, so they would draw as two loose rows and then collapse into
     one bundle block a second later. Union them now, at the same moment their
     price is being previewed, so the block is drawn once. */
  var pendingPair=(window.__fadPendingPairKeys||null);
  if(pendingPair&&pendingPair.length===2){
    var pi=[];
    items.forEach(function(it,i){if(pendingPair.indexOf(it.key)>=0)pi.push(i);});
    if(pi.length===2)union(pi[0],pi[1]);
  }
  /* weak pass: only for lines no strong signal has already bundled, and only
     when the shared value does not span the entire cart (that would be a
     generic tracking property, not a bundle marker) */
  var weakSeen={},weakCount={};
  sigs.forEach(function(sg){sg.weak.forEach(function(v){weakCount[v]=(weakCount[v]||0)+1;});});
  sigs.forEach(function(sg,i){
    if(sg.strong.length)return;
    sg.weak.forEach(function(v){
      if(weakCount[v]<2||weakCount[v]===items.length&&items.length>3)return;
      if(weakSeen[v]==null)weakSeen[v]=i;else union(weakSeen[v],i);
    });
  });

  var size={};
  items.forEach(function(it,i){var r=find(i);size[r]=(size[r]||0)+1;});

  var out=[],slot={};
  items.forEach(function(it,i){
    var root=find(i);
    var hasProp=false;
    for(var sI=0;sI<sigs[i].strong.length;sI++){if(sigs[i].strong[sI].indexOf('p:')===0){hasProp=true;break;}}
    var grouped=size[root]>1||hasProp||!!it.has_components;
    if(!grouped){out.push({bundle:false,items:[it]});return;}
    if(slot[root]==null){slot[root]=out.length;out.push({bundle:true,id:String(root),name:bundleNameOf(it),items:[]});}
    out[slot[root]].items.push(it);
  });
  out.forEach(function(g){
    var was=0,now=0;
    g.items.forEach(function(i){was+=lineWasOf(i);now+=netLineOf(i);});
    g.was=was;g.now=now;g.keys=g.items.map(function(i){return i.key;});
    if(g.bundle){
      /* v6.16: the offer name wins over anything derived from the discount
         title, which is the deal name and is the same for every offer in it. */
      var offerName=bundleNameFromOffer(g.items);
      /* v6.20: a pair that is still being stamped has no bid to read yet */
      if(!offerName&&window.__fadPendingPairKeys&&g.items.length===2&&
         g.items.every(function(i){return window.__fadPendingPairKeys.indexOf(i.key)>=0;})){
        offerName=FAD_BUNDLE_NAMES[FAD_KIT.pair]||'';
      }
      if(offerName){
        g.name=offerName;
      } else if(g.name==='Bundle'){
        for(var i=0;i<g.items.length;i++){var n=bundleNameOf(g.items[i]);if(n!=='Bundle'){g.name=n;break;}}
      }
    }
  });
  return out;
}
window.fadBundleDebug=function(){
  return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){
    setOrderAlloc(c);
    console.log('--- FAD bundle diagnostic ---');
    console.log('order-level discount allocated per line:', JSON.stringify(orderAlloc));
    c.items.forEach(function(i,n){
      console.log(n, i.product_title, '| props:', JSON.stringify(i.properties||{}), '| discounts:', JSON.stringify((i.line_level_discount_allocations||[]).map(function(d){return (d.discount_application||{}).title;})), '| signals:', JSON.stringify(bundleSignals(i)));
    });
    console.log('grouped into:', groupCartItems(c.items).map(function(g){return (g.bundle?'BUNDLE['+g.name+'] ':'single ')+g.items.map(function(i){return i.product_title;}).join(' + ');}));
    return c;
  });
};
function cartRemoveKeys(keys){
  var updates={};
  keys.forEach(function(k){updates[k]=0;});
  return fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({updates:updates})
  }).then(function(r){
    if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Cart update failed');});
    return r.json();
  });
}

/* ---- CART DRAWER ---- */
var drawerOpen=false;
function openDrawer(){
  var d=qs('#cart-drawer');
  if(!d)return;
  d.setAttribute('aria-hidden','false');
  drawerOpen=true;
  document.body.style.overflow='hidden';
  refreshDrawer();
}
function closeDrawer(){
  var d=qs('#cart-drawer');
  if(!d)return;
  d.setAttribute('aria-hidden','true');
  drawerOpen=false;
  document.body.style.overflow='';
}

function drawerBundleHtml(g){
  var saved=g.was-g.now;
  var h='<div class="drawer-bundle" data-keys="'+esc(g.keys.join(','))+'">';
  h+='<div class="drawer-bundle__head">';
  h+='<span class="drawer-bundle__pill">Bundle</span>';
  /* v6.34: when no offer name resolves, bundleNameOf falls back to the literal
     string "Bundle", which printed "BUNDLE Bundle" beside the pill. The pill
     already says it; a second copy is not a name. */
  if(g.name&&g.name!=='Bundle')h+='<span class="drawer-bundle__name">'+esc(g.name)+'</span>';
  else h+='<span class="drawer-bundle__name"></span>';
  h+='<button class="drawer-bundle__remove" data-keys="'+esc(g.keys.join(','))+'" aria-label="Remove '+esc(g.name)+'"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5 3.5V2.5a.5.5 0 011 0v1m2 0V2.5a.5.5 0 011 0v1M3.5 3.5l1 8h5l1-8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg></button>';
  h+='</div>';
  /* v5.91: eager, and overlapped, so the line reads as a set of packs rather
     than a receipt. Lazy images never load inside a drawer that is hidden. */
  /* v5.98: this line described a Cores bundle and was being printed on every
     grouped line, so a Forever Kit read "1 packs, mixed flavours". Only Core
     bundles get it, and only when there is genuinely more than one pack. */
  var units=0, allCores=true;
  g.items.forEach(function(i){
    units+=i.quantity||1;
    /* The kit is titled "... + 2 Cores + Base", so a bare /cores/ test matches
       it too. Identify a Core pack by its handle or its "Cores: 3-Pack" name. */
    var isCore=/flavour-core/i.test(i.handle||'')||/cores:\s*\d+\s*-?\s*pack/i.test(i.product_title||'');
    if(!isCore)allCores=false;
  });
  if(allCores&&units>1){
    h+='<p class="drawer-bundle__count">'+units+' packs, mixed flavours</p>';
  }
  /* v6.07: the layout below was designed for a six flavour Core bundle. A kit
     bundle is a single product, so the thumbnail rail and the itemised list
     just repeat the name twice and make one line take half the drawer. Small
     groups get a compact treatment; the rail and list are for real multi-item
     bundles. */
  var compact=g.items.length<3;
  if(compact)h=h.replace('<div class="drawer-bundle" ','<div class="drawer-bundle drawer-bundle--compact" ');
  if(!compact){
    var thumbs='';
    g.items.slice(0,5).forEach(function(i,ix){
      if(i.image)thumbs+='<span class="drawer-bundle__thumbwrap" style="z-index:'+(9-ix)+'"><img src="'+esc(i.image)+'" alt="'+esc(i.product_title)+'" width="40" height="40" class="drawer-bundle__thumb" loading="eager" decoding="async"></span>';
    });
    if(g.items.length>5)thumbs+='<span class="drawer-bundle__more">+'+(g.items.length-5)+'</span>';
    if(thumbs)h+='<div class="drawer-bundle__thumbs">'+thumbs+'</div>';
  } else {
    /* v6.15 FIX: this rendered g.items[0] and nothing else, so a bundle of two
       separately added kits showed ONE kit line carrying the price of both.
       Every item in the group gets its own row. Two 46px rows is still far
       less chrome than the thumb rail plus the itemised list. */
    g.items.forEach(function(it){
      h+='<div class="drawer-bundle__compactrow">';
      /* v6.34: was 46px. A kit added through a Kaching offer is a one-item
         group, so it renders through this path - which meant the single most
         expensive thing in the cart was drawn at half the size of an ordinary
         line and did not read as being in the cart at all. Same size as every
         other cart line now. */
      if(it.image)h+='<img src="'+esc(it.image)+'" alt="'+esc(it.product_title)+'" width="88" height="88" class="drawer-bundle__compactimg" loading="eager" decoding="async">';
      h+='<span class="drawer-bundle__compactname">'+esc(it.product_title)
        +(it.variant_title&&it.variant_title!=='Default Title'?' <span class="drawer-bundle__variant">'+esc(it.variant_title)+'</span>':'')
        +(it.quantity>1?' <span class="drawer-bundle__qty">x'+it.quantity+'</span>':'')+'</span>';
      /* each row carries its own price once there is more than one, so the
         group total below is checkable against the lines above it */
      if(g.items.length>1){
        var iWas=lineWasOf(it),iNow=netLineOf(it);
        h+='<span class="drawer-bundle__compactprice">'
          +(iWas>iNow?'<span class="line-was">'+formatMoney(iWas)+'</span> ':'')
          +'<span class="line-now">'+formatMoney(iNow)+'</span></span>';
        /* v6.18: the group's own remove button takes the whole bundle. With two
           kits in it the customer needs to drop just one and fall back to the
           single-kit price, so each row gets its own control. */
        h+='<button class="drawer-bundle__rowremove" data-key="'+esc(it.key)+'" aria-label="Remove one '+esc(it.product_title)+'">'
          +'<svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5 3.5V2.5a.5.5 0 011 0v1m2 0V2.5a.5.5 0 011 0v1M3.5 3.5l1 8h5l1-8" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg></button>';
      }
      h+='</div>';
    });
  }
  if(!compact)h+='<ul class="drawer-bundle__list">';
  if(!compact)g.items.forEach(function(i){
    var name=esc(i.product_title);
    if(i.variant_title&&i.variant_title!=='Default Title')name+=' <span class="drawer-bundle__variant">'+esc(i.variant_title)+'</span>';
    /* v5.45: each component carries its own price, discount included, so
       the line prices and the bundle total tell the same story. */
    var iWas=lineWasOf(i),iNow=netLineOf(i);
    var price='<span class="drawer-bundle__line-price">'
      +(iWas>iNow?'<span class="line-was">'+formatMoney(iWas)+'</span> ':'')
      +'<span class="line-now">'+formatMoney(iNow)+'</span></span>';
    h+='<li><span class="drawer-bundle__qty">'+i.quantity+'x</span> <span class="drawer-bundle__line-name">'+name+'</span>'+price+'</li>';
  });
  if(!compact)h+='</ul>';
  h+='<p class="drawer-bundle__price">';
  if(saved>0)h+='<span class="line-was">'+formatMoney(g.was)+'</span> ';
  h+='<span class="line-now">'+formatMoney(g.now)+'</span>';
  if(saved>0)h+='<span class="drawer-bundle__save">You save '+formatMoney(saved)+'</span>';
  h+='</p>';
  h+='</div>';
  return h;
}

/* ---- v5.71: ADD-FROM-CART CORE UPSELL --------------------------------
   Renders the upsell collection as cards with a real add button on each, so a
   shopper never has to leave the cart to add a Core bundle. Data comes from
   window.theme.coreUpsell, rendered by theme.liquid, so there is no runtime
   product fetch and the rail paints with the drawer.

   v5.71: returns HTML rather than appending, because the rail is needed in TWO
   places - under the cart lines, and inside the empty-cart state. renderDrawer
   returns early on an empty cart, so the v5.70 inline version never rendered
   for the shopper most likely to need a nudge: the one with nothing in the cart.

   Variants already in the cart show as "In cart" rather than being hidden, so
   the rail does not reflow under the shopper's finger mid-scroll. */
/* ---- v5.76: MIXED FLAVOUR CORE BUNDLES IN THE CART DRAWER ------------
   The Cores bundles are Kaching quantity breaks with COLLECTION BREAKS
   enabled, so a bundle is not N of one flavour: it is N separate lines the
   shopper picks individually. Captured from the PDP's own add request with
   all six slots filled with different flavours:

     main line     {deal, pp:<product id>, main:true, v, id:<offer>, bid:<tier>}
     partner lines {id:<offer>, deal, v, collectionBreaksProduct:true}

   Every line is quantity 1. The stamp is what prices them, so a bundle can
   never be reproduced by adding a quantity. This is the same shape the kit
   bundle (FAD_QWF) already uses, with the Cores deal's own ids.

   deal, offerId and every bid are constant across all six flavours; only pp
   changes, and only on the main line. Tier ids and quantities read out of
   Kaching's own deal config on the product page.

   PRICES ARE MIRRORED FROM KACHING AND CANNOT BE READ AT RUNTIME. Edit the
   Cores offer in the Kaching admin and these rows must be edited to match. */
var FAD_CORE_BUNDLES={
  deal:'puHs',
  offerId:'OF9X',
  tiers:[
    {bid:'L-1L',label:'6 Pack Bundle', packs:6, price:3899, compare:5994,  save:35},
    {bid:'Zv7q',label:'12 Pack Bundle',packs:12,price:6599, compare:11988, save:45, ribbon:'Best value'}
  ]
};
/* The bundle instance uuid that ties a main line to its partner lines.

   Kaching only mints one when its widget renders, which happens on product
   pages. Verified in a clean tab: on the homepage Kaching's script loads and
   kachingBundlesApi.fetchDeals() works, but the only uuids it exposes are deal
   ids, and its own storage holds a session id that is NOT this value. So a
   shopper who goes straight from an ad to the cart has no instance id, and
   withholding the tiles from them removes the offer from the exact case it
   exists for: a kit in the cart and no Cores yet.

   So we mint one when Kaching has not. It is a grouping token, and the add is
   verified afterwards (see cbundleVerify) rather than trusted, so a minted id
   that Kaching declines to honour is caught and rolled back instead of leaving
   someone paying six full prices.

   Order: a stamped line already in the cart, then Kaching's input on this page,
   then the one we stashed, then a fresh one. Real ones always win. */
function coreBundleMintV(){
  try{
    if(window.crypto&&window.crypto.randomUUID)return window.crypto.randomUUID();
  }catch(e){}
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){
    var r=Math.random()*16|0;
    return (c==='x'?r:((r&0x3)|0x8)).toString(16);
  });
}
function coreBundleInstance(cart){
  var items=(cart&&cart.items)||[];
  for(var i=0;i<items.length;i++){
    try{
      var st=JSON.parse((items[i].properties||{}).__kaching_bundles);
      if(st&&st.v)return st.v;
    }catch(e){}
  }
  try{
    var el=document.querySelector('[name="properties[__kaching_bundles]"]');
    if(el){ var p=JSON.parse(el.value); if(p&&p.v){ try{localStorage.setItem('fadQwfV',p.v);}catch(_){ } return p.v; } }
  }catch(e){}
  try{ var v=localStorage.getItem('fadQwfV'); if(v)return v; }catch(e){}
  var fresh=coreBundleMintV();
  try{ localStorage.setItem('fadQwfV',fresh); }catch(e){}
  return fresh;
}
/* "FaD Cool Mint Cores: 3-Pack" -> "Cool Mint" */
function coreFlavourName(title){
  return String(title).replace(/^FaD\s+/i,'').replace(/\s*Cores.*$/i,'').trim()||title;
}
function coreFlavourList(upsell){
  var out=[];
  (upsell||[]).forEach(function(p){
    var av=(p.variants||[]).filter(function(x){return x.available;})[0];
    if(av&&p.pid)out.push({name:coreFlavourName(p.title),vid:av.id,pid:p.pid,image:p.image,price:av.price});
  });
  return out;
}
/* One stacked block per tier. Full width rather than a card in the scroll
   rail, because a six-row flavour picker cannot work in a 160px tile. */
function coreBundleBlockHtml(tier,flavours){
  if(flavours.length<2)return '';
  var per=Math.round(tier.price/tier.packs);
  /* the cheapest single pack on the store: what a pack costs bought alone */
  var single=0;
  flavours.forEach(function(f){var p=f.price||0;if(p&&(!single||p<single))single=p;});
  var h='<div class="cbundle'+(tier.ribbon?' cbundle--featured':'')+'" data-bid="'+tier.bid+'" data-packs="'+tier.packs+'">';
  if(tier.ribbon)h+='<span class="cbundle__ribbon">'+esc(tier.ribbon)+'</span>';

  /* Overlapping Core photos. A bundle sold as a row of text reads as a form;
     the packs themselves are what makes it feel like something to own. */
  h+='<div class="cbundle__top">';
  h+='<span class="cbundle__stack">';
  var shown=flavours.slice(0,4);
  shown.forEach(function(f,i){
    h+='<span class="cbundle__chip" style="z-index:'+(9-i)+'">';
    if(f.image)h+='<img src="'+esc(f.image)+'" alt="" width="40" height="40" loading="eager" decoding="async">';
    h+='</span>';
  });
  if(flavours.length>shown.length)h+='<span class="cbundle__chip cbundle__chip--more">+'+(flavours.length-shown.length)+'</span>';
  h+='</span>';
  /* v6.38: "Mix any flavours you like" said nothing the customer could act
     on. The per-pack saving is a second, smaller number that reinforces the
     first one, and it is derived from the cheapest single pack on the store
     rather than written down anywhere it could go stale. */
  /* v6.40: v6.38 put the per-pack dollar saving here as a subheading. It read
     as a second price tag hanging off the product name, and it duplicated the
     "$6.50 a pack" already sitting on the price row two lines below. The
     subheading goes back to describing the thing. */
  h+='<span class="cbundle__headline"><span class="cbundle__title">'+esc(tier.label)+'</span>'
    +'<span class="cbundle__meta">Mix any flavours you like</span></span>';
  h+='</div>';

  /* v6.38: the saving was a small pill and the price was the big number, so
     the card shouted the cost and whispered the win. Reversed. The prices are
     still both shown, in full and struck, because that is what makes the
     saving checkable rather than a claim. */
  h+='<div class="cbundle__pricerow">';
  h+='<span class="cbundle__saveamt">Save '+tier.save+'%</span>';
  h+='<span class="cbundle__prices">'
    +'<span class="cbundle__was">'+formatMoney(tier.compare)+'</span>'
    +'<span class="cbundle__now">'+formatMoney(tier.price)+'</span>'
    +'</span>';
  h+='<span class="cbundle__unit">'+formatMoney(per)+' a pack</span>';
  h+='</div>';

  /* v6.37 WORDING: was "Pick your 6 flavours", which reads as a task the
     customer has to complete. It is the same control, named after what is
     behind it rather than after the work. */
  h+='<button type="button" class="cbundle__toggle" aria-expanded="false">'
    +'<span>Choose your '+tier.packs+' flavours</span>'
    +'<svg class="cbundle__caret" width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true">'
    +'<path d="M2.5 4.5L6 8l3.5-3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    +'</button>';

  h+='<div class="cbundle__picker" hidden>';
  /* v6.33: the add button used to sit under six flavour rows, so the customer
     had to scroll past the whole list to reach it and could not see it while
     choosing. It now opens directly under the toggle with the counter and the
     progress bar, in view the entire time the picker is open. */
  h+='<div class="cbundle__foot">';
  h+='<span class="cbundle__count">Tap + to pick '+tier.packs+' packs</span>';
  /* v6.37 WORDING: the disabled button used to say "Add bundle", which names
     the thing it will not do. It now says what has to happen first, and turns
     into the price the moment it can be pressed. */
  h+='<button type="button" class="cbundle__add" disabled>Pick your packs below</button>';
  h+='</div>';
  /* filling a bar is a small reward loop; an empty counter is a chore */
  h+='<div class="cbundle__progress"><span class="cbundle__progress-fill" style="width:0%"></span></div>';
  flavours.forEach(function(f){
    h+='<div class="cbundle__row" data-vid="'+f.vid+'" data-pid="'+f.pid+'">';
    h+='<span class="cbundle__thumb">';
    if(f.image)h+='<img src="'+esc(f.image)+'" alt="" width="34" height="34" loading="eager" decoding="async">';
    h+='</span>';
    h+='<span class="cbundle__flav">'+esc(f.name)+'</span>';
    h+='<span class="cbundle__step">';
    h+='<button type="button" class="cbundle__btn" data-step="-1" aria-label="One less '+esc(f.name)+'">&minus;</button>';
    h+='<span class="cbundle__n" aria-live="polite">0</span>';
    h+='<button type="button" class="cbundle__btn" data-step="1" aria-label="One more '+esc(f.name)+'">+</button>';
    h+='</span></div>';
  });
  h+='</div></div>';
  return h;
}
function upsellRailHtml(cart,expanded){
  var upsell=(window.theme&&window.theme.coreUpsell)||[];
  if(!upsell.length)return '';
  /* v5.76: bundles only. Single packs were removed at the merchant's request:
     the drawer's job here is to move someone from one pack to six or twelve,
     and a $9.99 tile sitting beside a $38.99 one argues against that. */
  var v=coreBundleInstance(cart);
  if(!v)return '';
  var flavours=coreFlavourList(upsell);
  if(flavours.length<2)return '';
  var blocks='';
  FAD_CORE_BUNDLES.tiers.forEach(function(t){ blocks+=coreBundleBlockHtml(t,flavours); });
  if(!blocks)return '';
  var items=(cart&&cart.items)||[];
  var KIT_HANDLES=['fad-wood-inhaler','fad-steel-inhaler'];
  var hasKit=items.some(function(i){return KIT_HANDLES.indexOf(i.handle)>=0;});
  var best=FAD_CORE_BUNDLES.tiers[FAD_CORE_BUNDLES.tiers.length-1].save;
  var colUrl=(window.theme&&window.theme.coreCollectionUrl)||'/collections/core-packs';
  var moreLabel=flavours.length>1?('See all '+flavours.length+' flavours'):'See all flavours';
  var more='<a class="cupsell__more" href="'+esc(colUrl)+'">'+moreLabel
    +'<svg class="cupsell__more-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">'
    +'<path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';

  /* The single number that makes the case: normal pack price struck through
     against the best per-pack price a bundle reaches. */
  var unit=0;
  flavours.forEach(function(f){
    var p=(f.price||0);
    if(p&&(!unit||p<unit))unit=p;
  });
  if(!unit)unit=999;
  var bestTier=FAD_CORE_BUNDLES.tiers[FAD_CORE_BUNDLES.tiers.length-1];
  var bestPer=Math.round(bestTier.price/bestTier.packs);
  var compare='<p class="cupsell__compare">'
    +'<span class="cupsell__compare-was">'+formatMoney(unit)+'</span>'
    +'<span class="cupsell__compare-now">'+formatMoney(bestPer)+'</span>'
    +'<span class="cupsell__compare-label">a pack in a bundle</span></p>';

  var open=(expanded===true);
  if(open){
    /* empty cart: the rail is the whole content, so it carries its own heading */
    var inner='<div class="cupsell__head">'
      +'<div class="cupsell__headrow">'
      +'<p class="cupsell__headline">Bundle your Cores, save up to '+best+'%</p>'
      +more
      +'</div>'
      +compare
      +'<p class="cupsell__sub">'+(hasKit
          ?'Mix any flavours. Goes out in the same parcel.'
          :'Mix any flavours you like across the bundle.')+'</p>'
      +'</div>'+blocks;
    return '<div class="cupsell cupsell--open" id="cart-upsell">'
      +'<div class="cupsell__panel">'+inner+'</div></div>';
  }

  /* ---- v6.37: THE BAR -------------------------------------------------
     The v6.34 bar was two lines of grey type and a green pill that said ADD
     and did not add anything, which is both boring and a lie. Nothing about
     it said there were six flavours behind it.

     The flavours now sit ON the bar as overlapping photos, the price hook is
     the headline rather than a percentage, and the control says what it
     actually does. Same layout, same accordion, honest button. */
  /* ---- v6.38: SAVINGS, NOT COST --------------------------------------
     Every version of this bar so far led with a price: "$5.50 a pack",
     "$38.99", "singles are $9.99". All of it is what the customer PAYS, and
     none of it is what they GET OFF. A price is a reason to hesitate. The
     amount coming off is the reason to act, so that is the headline now and
     the prices have moved down to the tier cards where they belong.

     Dollars rather than percent: 45% is a ratio somebody has to do sums on,
     $53 is money. Both figures come straight out of the Kaching tier config,
     so they cannot drift from what the cart actually charges. */
  /* v6.39: back to percent. v6.38 ran these as dollar figures on the theory
     that $53 lands harder than 45%. The merchant reads the percentage as the
     stronger signal on this catalogue and that is his call. The v6.38
     hierarchy is untouched: the saving is still the largest thing in every
     place it appears and the prices still support it. Only the unit changed. */
  var bestSave=0;
  FAD_CORE_BUNDLES.tiers.forEach(function(t){
    if((t.save||0)>bestSave)bestSave=t.save||0;
  });
  var bestSaveLabel=bestSave+'%';
  /* the flavours themselves, named. "6 flavours" is a count; "Mint, Mango,
     Coffee and 3 more" is something to want. */
  var barNames=flavours.slice(0,2).map(function(f){return f.name;});
  var barFlavourLine=barNames.join(', ');
  if(flavours.length>barNames.length)barFlavourLine+=' and '+(flavours.length-barNames.length)+' more';

  /* three photos plus the count. Four left the text column too narrow at
     390px and the headline wrapped onto a second line, which is what made the
     bar tall and the sub-line cramped. */
  var barShown=flavours.slice(0,3);
  var barStack='<span class="cupsell__bar-stack">';
  barShown.forEach(function(f,i){
    barStack+='<span class="cupsell__bar-chip" style="z-index:'+(9-i)+'">';
    if(f.image)barStack+='<img src="'+esc(f.image)+'" alt="" width="40" height="40" loading="eager" decoding="async">';
    barStack+='</span>';
  });
  if(flavours.length>barShown.length)barStack+='<span class="cupsell__bar-chip cupsell__bar-chip--more">+'+(flavours.length-barShown.length)+'</span>';
  barStack+='</span>';

  /* v6.37: the panel used to open onto "$9.99 $5.50 a pack in a bundle",
     which is word for word what the bar the customer just tapped already
     said. It opens onto the bundles now. */
  /* ---- v6.42: THE LINE ABOVE THE BUNDLES ------------------------------
     "Two ways to save." described the menu. It asked for nothing and it knew
     nothing about the cart it was sitting in.

     Free shipping is the strongest reason to add Cores NOW rather than in a
     second order, and the drawer already knows whether this cart has earned
     it. So the line reads the cart:

       already free   -> the postage is paid for, anything added rides along.
                         This is the case that matters: a customer about to
                         check out on a kit is one tap from adding Cores for
                         nothing extra in freight, and nothing was telling them.
       a bundle wins it -> adding one crosses the threshold. Say so.
       neither        -> fall back to the plain line.

     Measured against the same threshold and the same shipStateFor() the
     progress bar and the Shipping row use, so the three can never disagree. */
  var railNet=Math.max(0,(cart&&cart.total_price)||0);
  var railShip=shipStateFor(railNet,cart);
  /* the SMALLEST tier that actually crosses the threshold from where this
     cart sits. A $9.99 cart plus the 6 pack is $48.98, still short of $60, so
     promising free shipping off "a bundle" there would be a lie the customer
     discovers at checkout. */
  var cheapestTier=null,unlockTier=null;
  FAD_CORE_BUNDLES.tiers.forEach(function(t){
    if(!cheapestTier||t.price<cheapestTier.price)cheapestTier=t;
    if(railNet+t.price>=shipThreshold()){
      if(!unlockTier||t.price<unlockTier.price)unlockTier=t;
    }
  });
  var noteLine;
  if(railShip.free){
    /* v6.44 CORRECTION: this said "Don't pay postage twice", which is false
       for the case it fires in most often. Nearly every cart that reaches this
       branch holds an $89 kit, so it has already cleared the $60 threshold -
       and a later Cores order at bundle prices clears it too. Nobody was going
       to pay twice, and a cart that argues from a premise the customer can see
       through costs more than the line was ever going to win.

       When shipping is already free, shipping is not the lever. What IS true,
       and is not already said by the bar directly above, is that Cores added
       now travel in this parcel instead of arriving in a second delivery
       later. So that is what it says. */
    /* v6.49: this branch only ever renders on a cart that has already cleared
       the threshold, so "while shipping is free" is true every time it is
       shown, unlike the v6.44 "don't pay postage twice" it replaced. */
    noteLine='<p class="cupsell__panelnote cupsell__panelnote--ship">'
      +'Add your Cores while shipping is free.</p>';
  }else if(unlockTier){
    /* The progress bar above already says how far off free shipping they are,
       so repeating the gap here would be the third element on screen counting
       the same dollars. This line stacks the two things a bundle wins at once
       instead: the discount AND the postage. */
    noteLine='<p class="cupsell__panelnote cupsell__panelnote--ship">'
      +(unlockTier===cheapestTier
          ? 'One bundle. Up to '+bestSave+'% off and free shipping.'
          : 'The '+unlockTier.packs+' pack. '+unlockTier.save+'% off and free shipping.')
      +'</p>';
  }else{
    noteLine='<p class="cupsell__panelnote">Two ways to save.</p>';
  }

  /* ---- v6.47: WHERE THE FLAVOUR LINK GOES ----------------------------
     v6.46 deleted this link on the argument that it leaks a sale out of the
     cart at the decision moment. That argument is wrong. Somebody who wants to
     see what a Core actually is and cannot does not add the bundle either way,
     they just leave, so the link is not costing a conversion, it is rescuing
     one. The cart persists, so they come back to it. The 30px thumbnails in
     the picker are enough to recognise a flavour you already know and not
     enough to discover one.

     What was wrong was the placement. As a pill on the note's row it forced a
     second row that was empty apart from itself, about 45px of nothing,
     because the note wraps at 390px. It now sits UNDER both tier cards: no
     row of its own to share, no dead space, and it is offered at the point a
     shopper has seen both offers and might want a proper look before
     committing, which is the moment it is actually useful. */
  var body='<div class="cupsell__head cupsell__head--bar">'
    +noteLine
    +'</div>'
    +blocks
    +'<a class="cupsell__more cupsell__more--foot" href="'+esc(colUrl)+'">'+moreLabel
    +'<svg class="cupsell__more-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">'
    +'<path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';

  return '<div class="cupsell is-collapsed" id="cart-upsell">'
    +'<button type="button" class="cupsell__bar" aria-expanded="false" aria-controls="cart-upsell-panel">'
    +barStack
    +'<span class="cupsell__bar-main">'
    +'<span class="cupsell__bar-title">Save up to <span class="cupsell__bar-amt">'+bestSaveLabel+'</span> on Cores</span>'
    +'<span class="cupsell__bar-sub">'+barFlavourLine+'</span>'
    +'</span>'
    +'<span class="cupsell__bar-go">'
    +'<svg class="cupsell__bar-caret" width="13" height="13" viewBox="0 0 12 12" fill="none" aria-hidden="true">'
    +'<path d="M2.5 4.5L6 8l3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    +'</span>'
    +'</button>'
    +'<div class="cupsell__panel" id="cart-upsell-panel" hidden>'+body+'</div></div>';
}
/* ---- v6.34: DISCOUNT CODES IN THE CART DRAWER -----------------------
   Shopify exposes no AJAX endpoint for discount codes. Two paths exist in the
   wild and neither is documented:

     POST /cart/update.js {"discount":"CODE"}   works on most shops, silently
                                                ignored on some
     GET  /discount/CODE                        sets the discount cookie

   Both are fired, then the CART decides. The code is only reported as applied
   if the re-read /cart.js lists it in discount_codes with applicable !== false.
   Nothing is trusted from the request itself, because a 200 from either path
   does not mean the cart took the code - and telling a customer a code worked
   when it did not is how you get a chargeback conversation at checkout.

   The checkout link also carries ?discount=CODE while a code is on, so the code
   survives even if the cookie is dropped between the drawer and checkout. */
function cartCodeDiscount(cart){
  var out={code:'',codes:[],amount:0};
  if(!cart)return out;
  (cart.discount_codes||[]).forEach(function(d){
    if(d&&d.code&&d.applicable!==false)out.codes.push(d.code);
  });
  if(!out.codes.length)return out;
  var total=0;
  (cart.cart_level_discount_applications||[]).forEach(function(a){
    if(a&&a.type==='discount_code')total+=(a.total_allocated_amount||0);
  });
  (cart.items||[]).forEach(function(it){
    (it.line_level_discount_allocations||[]).forEach(function(al){
      var da=al&&(al.discount_application||al);
      if(da&&da.type==='discount_code')total+=(al.amount||0);
    });
  });
  /* last resort: the figure Shopify puts on the code itself */
  if(!total){
    (cart.discount_codes||[]).forEach(function(d){
      if(!d||d.applicable===false)return;
      var amt=(typeof d.amount==='number')?d.amount:parseInt(d.amount,10);
      if(!isNaN(amt))total+=amt;
    });
  }
  out.amount=Math.max(0,total);
  out.code=out.codes.join(', ');
  return out;
}
/* One label, one figure, hidden when there is nothing to report. */
function setSumRow(rowSel,valSel,amount){
  var row=qs(rowSel),val=qs(valSel);
  if(!row)return;
  if(amount>0){
    if(val)val.textContent='−'+formatMoney(amount);
    row.hidden=false;
  }else{
    row.hidden=true;
  }
}
function discMsg(text,isErr){
  var el=qs('#drawer-disc-msg');
  if(!el)return;
  if(!text){el.hidden=true;el.textContent='';el.classList.remove('is-err');return;}
  el.textContent=text;
  if(isErr)el.classList.add('is-err');else el.classList.remove('is-err');
  el.hidden=false;
}
function discBusy(state,label){
  var btn=qs('#drawer-disc-apply');
  if(!btn)return;
  btn.disabled=!!state;
  btn.textContent=state?(label||'Applying'):'Apply';
}
/* The real reason, not a generic "invalid". A code refused because the cart
   already carries an automatic bundle discount is a combination rule, not a
   dead code, and the customer needs to be told which it is. */
function discRejectReason(cart,code){
  var CODE=String(code||'').toUpperCase();
  var other=((cart&&cart.discount_codes)||[]).filter(function(d){
    return d&&d.applicable!==false&&d.code&&d.code.toUpperCase()!==CODE;
  })[0];
  if(other)return 'Shopify allows one discount code per order. Remove '+other.code+' to use '+CODE+'.';
  var listed=((cart&&cart.discount_codes)||[]).filter(function(d){
    return d&&d.code&&d.code.toUpperCase()===CODE;
  })[0];
  var hasAuto=((cart&&cart.cart_level_discount_applications)||[]).some(function(a){
    return a&&a.type&&a.type!=='discount_code';
  })||((cart&&cart.items)||[]).some(function(it){
    return ((it.line_level_discount_allocations)||[]).some(function(al){
      var da=al&&(al.discount_application||al);
      return da&&da.type&&da.type!=='discount_code';
    });
  });
  if(listed&&hasAuto)return CODE+' cannot be combined with the bundle discount already on your cart.';
  if(listed)return CODE+' does not apply to anything in your cart.';
  if(hasAuto)return CODE+' was not accepted. It may not combine with the bundle discount on your cart, or it has expired.';
  return CODE+' is not a valid code, or it has expired.';
}
function syncCheckoutLink(cart){
  var a=qs('#drawer-checkout');
  if(!a)return;
  var codes=((cart&&cart.discount_codes)||[]).filter(function(d){return d&&d.code&&d.applicable!==false;});
  a.href=codes.length?('/checkout?discount='+encodeURIComponent(codes[0].code)):'/checkout';
}
function renderDiscountChips(cart){
  syncCheckoutLink(cart);
  var wrap=qs('#drawer-disc-chips');
  var toggle=qs('#drawer-disc-toggle');
  if(!wrap)return;
  var codes=((cart&&cart.discount_codes)||[]).filter(function(d){return d&&d.code&&d.applicable!==false;});
  if(!codes.length){
    wrap.hidden=true;
    wrap.innerHTML='';
    if(toggle)toggle.hidden=false;
    return;
  }
  var h='';
  codes.forEach(function(d){
    h+='<span class="cart-disc__chip">'
      +'<span class="cart-disc__chip-code">'+esc(d.code)+'</span>'
      +'<button type="button" class="cart-disc__remove" data-code="'+esc(d.code)+'" aria-label="Remove discount code '+esc(d.code)+'">'
      +'<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>'
      +'</button></span>';
  });
  wrap.innerHTML=h;
  wrap.hidden=false;
  /* the "Add discount code" line is noise once one is on */
  if(toggle)toggle.hidden=true;
}
function applyDiscountCode(code){
  code=String(code||'').trim();
  if(!code){discMsg('Enter a code first.',true);return Promise.resolve();}
  discMsg('');
  discBusy(true,'Applying');
  return fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json',Accept:'application/json'},
    body:JSON.stringify({discount:code})
  })
  .catch(function(){return null;})
  .then(function(){
    return fetch('/discount/'+encodeURIComponent(code),{
      method:'GET',credentials:'same-origin',headers:{Accept:'text/html'}
    }).catch(function(){return null;});
  })
  .then(function(){
    return fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
  })
  .then(function(r){return r.json();})
  .then(function(cart){
    renderDrawer(cart);
    var applied=((cart.discount_codes)||[]).filter(function(d){
      return d&&d.code&&d.code.toUpperCase()===code.toUpperCase()&&d.applicable!==false;
    })[0];
    if(applied){
      var saved=cartCodeDiscount(cart).amount;
      discMsg(saved>0?('Code applied. You saved '+formatMoney(saved)+'.'):'Code applied.',false);
      var inp=qs('#drawer-disc-input');
      if(inp)inp.value='';
      var panel=qs('#drawer-disc-panel');
      if(panel)panel.hidden=true;
      var tg=qs('#drawer-disc-toggle');
      if(tg)tg.setAttribute('aria-expanded','false');
    }else{
      discMsg(discRejectReason(cart,code),true);
    }
  })
  .catch(function(){
    discMsg('Could not reach the cart. Check your connection and try again.',true);
  })
  .then(function(){discBusy(false);});
}
function removeDiscountCode(code){
  discMsg('');
  return fetch('/cart/update.js',{
    method:'POST',
    headers:{'Content-Type':'application/json',Accept:'application/json'},
    body:JSON.stringify({discount:''})
  })
  .catch(function(){return null;})
  .then(function(){
    return fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
  })
  .then(function(r){return r.json();})
  .then(function(cart){
    renderDrawer(cart);
    var still=((cart.discount_codes)||[]).some(function(d){
      return d&&d.code&&d.code.toUpperCase()===String(code).toUpperCase()&&d.applicable!==false;
    });
    /* honest about the one case this cannot fix: some shops ignore the
       discount key, and the cookie can then only be cleared at checkout */
    if(still)discMsg('This store will not let the code be removed from the cart. You can remove it on the checkout page.',true);
  })
  .catch(function(){
    discMsg('Could not reach the cart. Check your connection and try again.',true);
  });
}
function initDiscountCode(){
  on(document,'click',function(e){
    var tg=e.target.closest&&e.target.closest('#drawer-disc-toggle');
    if(!tg)return;
    e.preventDefault();
    var panel=qs('#drawer-disc-panel');
    if(!panel)return;
    var open=panel.hidden;
    panel.hidden=!open;
    tg.setAttribute('aria-expanded',open?'true':'false');
    if(open){
      var inp=qs('#drawer-disc-input');
      if(inp)setTimeout(function(){inp.focus();},30);
    }
  });
  on(document,'submit',function(e){
    var f=e.target.closest&&e.target.closest('#drawer-disc-form');
    if(!f)return;
    e.preventDefault();
    var inp=qs('#drawer-disc-input');
    applyDiscountCode(inp?inp.value:'');
  });
  on(document,'click',function(e){
    var rm=e.target.closest&&e.target.closest('.cart-disc__remove');
    if(!rm)return;
    e.preventDefault();
    removeDiscountCode(rm.getAttribute('data-code')||'');
  });
  /* v6.34: the Core offer is collapsed by default inside a cart that has
     something in it, so the customer's own items and the totals are what the
     drawer is about. One tap opens it. */
  on(document,'click',function(e){
    var bar=e.target.closest&&e.target.closest('.cupsell__bar');
    if(!bar)return;
    e.preventDefault();
    var wrap=bar.closest('.cupsell');
    var panel=wrap&&wrap.querySelector('.cupsell__panel');
    if(!panel)return;
    var open=panel.hidden;
    panel.hidden=!open;
    bar.setAttribute('aria-expanded',open?'true':'false');
    if(open&&wrap&&wrap.scrollIntoView){
      setTimeout(function(){
        try{wrap.scrollIntoView({behavior:'smooth',block:'nearest'});}catch(_){}
      },60);
    }
  });
}

function renderDrawer(cart){
  window.__fadLastCart=cart;
  /* v5.56: never paint the empty cart mid-swap (see fadQwfInFlight) */
  if(kitBusy&&(!cart||!cart.item_count))return;
  /* v5.45: must run before any price is read or grouped. */
  setOrderAlloc(cart);
  /* v6.20: fold in the offer the cart is about to receive, so lines and totals
     paint at their final price instead of the undiscounted one. */
  var previewOff=applyKitPreview(cart);
  window.__fadPendingPairKeys=kitPendingPairKeys(cart);
  var emptyEl=qs('#cart-drawer-empty');
  var itemsEl=qs('#cart-drawer-items');
  var footerEl=qs('#cart-drawer-footer');
  var countEl=qs('#drawer-count');
  var subtotalEl=qs('#drawer-subtotal');
  var originalEl=qs('#drawer-original');
  var savingsEl=qs('#drawer-savings');
  if(countEl)countEl.textContent=cart.item_count>0?'('+cart.item_count+')':'';
  updateCartBadge(cart.item_count);
  if(cart.item_count===0){
    /* v5.71: an empty cart is the strongest place to show the rail, not the
       weakest. Paint it into the empty state before returning. */
    var emptyUpsellEl=qs('#cart-drawer-empty-upsell');
    if(emptyUpsellEl)emptyUpsellEl.innerHTML=upsellRailHtml(cart,true);
    showEl(emptyEl);
    hideEl(itemsEl);
    hideEl(footerEl);
    return;
  }
  hideEl(emptyEl);
  showEl(itemsEl);
  showEl(footerEl);
  /* ---- v6.34: SUMMARY TABLE ------------------------------------------
     The old footer painted one number (net) with a struck RRP above it and a
     savings pill beside it, and left shipping and the gift to a separate
     two-column strip. Three different shapes carrying four facts.

     It is now one table, read top to bottom:
       Subtotal        RRP of everything in the cart
       Bundle savings  what the automatic offers took off
       Discount CODE   what a manually entered code took off
       Shipping        FREE with the rate struck, or the rate
       Free gift       FREE
       Total           what the customer pays, shipping included

     Splitting the code discount out of the bundle savings matters: both are
     already inside cart.total_price, so reporting the difference as one number
     would hide the code the customer just typed. */
  var origTotal=cartWasTotal(cart);
  /* v6.20: the total the customer will actually pay, including the offer that
     is still in flight. v5.57 showed "Applying bundle price..." here, which
     still meant the number arrived late. It is known now, so show it now. */
  var netTotal=Math.max(0,(cart.total_price||0)-previewOff);
  var codeInfo=cartCodeDiscount(cart);
  var codeAmt=codeInfo.amount;
  /* everything taken off that was not a typed code */
  var bundleSave=Math.max(0,origTotal-netTotal-codeAmt);
  /* v6.27: free shipping is money the customer is not paying, so it belongs in
     the saving. Counted only when the cart actually qualifies. */
  var ship=shipStateFor(netTotal,cart);
  var payTotal=netTotal+(ship.free?0:ship.cost);
  var saved=Math.max(0,origTotal-netTotal)+(ship.free?ship.cost:0);

  if(subtotalEl)subtotalEl.textContent=formatMoney(origTotal);
  var totalEl=qs('#drawer-total');
  if(totalEl)totalEl.textContent=formatMoney(payTotal);
  /* the struck figure now belongs to the total, not the subtotal, and only
     when it differs from what is actually being charged */
  if(originalEl){
    var wasPay=origTotal+ship.cost;
    if(wasPay>payTotal){originalEl.textContent=formatMoney(wasPay);showEl(originalEl);}
    else{hideEl(originalEl);}
  }
  /* v6.40: bundleSave is still computed, because it is what the Total row's
     struck price and the saving pill are both derived from. It just no longer
     gets a row of its own. */
  setSumRow('#drawer-code-row','#drawer-code-amt',codeAmt);
  var codeLabelEl=qs('#drawer-code-label');
  if(codeLabelEl)codeLabelEl.textContent=codeInfo.code||'';
  if(savingsEl){
    if(saved>0){savingsEl.textContent='Save '+formatMoney(saved);showEl(savingsEl);}
    else{hideEl(savingsEl);}
  }
  /* v6.34: keep the chips in the footer honest against what the cart actually
     holds, so a code the cart quietly dropped does not keep showing as applied */
  renderDiscountChips(cart);
  /* v6.30: how far off free shipping a Cores-only cart is. Hidden once the
     cart qualifies, because the shipping row below then says FREE and two
     elements saying the same thing is noise. The bar measures against what the
     customer will actually pay, so a bundle discount that drops the cart back
     under the threshold moves the bar back rather than lying about it. */
  var progEl=qs('#drawer-ship-progress'),progMsg=qs('#drawer-ship-progress-msg'),
      progFill=qs('#drawer-ship-progress-fill');
  if(progEl){
    if(ship.free||netTotal<=0){
      progEl.hidden=true;
    }else{
      progEl.hidden=false;
      /* capped at 99: rounding put a full bar next to "Add $0.06", so the bar
         said qualified while the message said not yet */
      var pct=Math.max(4,Math.min(99,Math.round(netTotal/shipThreshold()*100)));
      if(progFill)progFill.style.width=pct+'%';
      if(progMsg)progMsg.innerHTML='Add <strong>'+formatMoney(ship.remaining)+'</strong> for free shipping';
    }
  }
  /* v6.32: shown on every cart, because every order gets one */
  var giftRow=qs('#drawer-gift-row');
  if(giftRow)giftRow.hidden=false;
  var shipRow=qs('#drawer-ship-row'),shipLabel=qs('#drawer-ship-label'),
      shipWas=qs('#drawer-ship-was'),shipNow=qs('#drawer-ship-now');
  if(shipRow){
    shipRow.hidden=false;
    if(ship.free){
      /* v6.34: the row is a label and a figure like every other row now, so the
         state goes back in the value column: FREE, with the rate struck beside
         it. "Free shipping" as a label plus a struck number and no value read
         as a fragment in a table where every other line has a figure. */
      if(shipLabel)shipLabel.textContent='Shipping';
      if(shipWas){shipWas.textContent=formatMoney(ship.cost);shipWas.hidden=false;}
      if(shipNow){shipNow.textContent='FREE';shipNow.classList.add('is-free');shipNow.hidden=false;}
      shipRow.classList.add('is-free');
    }else{
      if(shipLabel)shipLabel.textContent='Shipping';
      if(shipWas)shipWas.hidden=true;
      if(shipNow){shipNow.textContent=formatMoney(ship.cost);shipNow.classList.remove('is-free');shipNow.hidden=false;}
      shipRow.classList.remove('is-free');
    }
  }
  /* v5.86: the free-shipping progress bar is gone. Shipping is free on the
     orders this drawer sees, so a meter that is always full was decoration
     that cost vertical space above the checkout button. */
  var html='';
  groupCartItems(cart.items).forEach(function(group){
    if(group.bundle){
      html+=drawerBundleHtml(group);
      return;
    }
    var item=group.items[0];
    var isBundle=item.properties&&item.properties._bndlr;
    /* ---- v6.34: ONE CART LINE SHAPE ---------------------------------
       The old line was a 72px image, a column carrying title, variant, price
       and a stepper stacked four deep, and a remove button floating at the far
       right of the row. Four rows of text beside a small square, with the
       control that changes the quantity sitting below the price it changes.

       Now: a large product image, the title and remove on the first line, the
       variant beneath it, and the stepper and the line price on one baseline at
       the bottom. Two rows instead of four, the image reads as the product, and
       every tap target clears 44px. */
    html+='<div class="drawer-item" data-key="'+esc(item.key)+'">';
    if(item.image)html+='<img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'" width="88" height="88" class="drawer-item__img" loading="eager" decoding="async">';
    html+='<div class="drawer-item__info">';
    html+='<div class="drawer-item__top">';
    html+='<a href="'+esc(item.url)+'" class="drawer-item__title">'+esc(item.product_title)+'</a>';
    html+='<button class="drawer-item__remove" data-key="'+esc(item.key)+'" aria-label="Remove '+esc(item.product_title)+'"><svg width="15" height="15" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 3.5h10M5 3.5V2.5a.5.5 0 011 0v1m2 0V2.5a.5.5 0 011 0v1M3.5 3.5l1 8h5l1-8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg></button>';
    html+='</div>';
    if(item.variant_title&&item.variant_title!=='Default Title')html+='<p class="drawer-item__variant">'+esc(item.variant_title)+'</p>';
    /* v5.36: label only real bundles (multi-unit lines); no text on single devices */
    if(isBundle&&item.quantity>1)html+='<p class="drawer-item__variant">Bundle deal pricing</p>';
    var lineWas=lineWasOf(item);
    html+='<div class="drawer-item__bottom">';
    html+='<div class="drawer-item__qty">';
    html+='<button class="drawer-qty-btn" data-action="dec" data-key="'+esc(item.key)+'" aria-label="Decrease quantity">&minus;</button>';
    html+='<span class="drawer-qty-val">'+item.quantity+'</span>';
    html+='<button class="drawer-qty-btn" data-action="inc" data-key="'+esc(item.key)+'" aria-label="Increase quantity">+</button>';
    html+='</div>';
    html+='<p class="drawer-item__price">'
      +(lineWas>netLineOf(item)?'<span class="line-was">'+formatMoney(lineWas)+'</span> ':'')
      +'<span class="line-now">'+formatMoney(netLineOf(item))+'</span>'
      +(item.quantity>1?'<span class="drawer-item__unit">'+item.quantity+' x '+formatMoney(netUnitOf(item))+'</span>':'')
      +'</p>';
    html+='</div>';
    html+='</div></div>';
  });
  html+=upsellRailHtml(cart);
  if(itemsEl)itemsEl.innerHTML=html;
}
function refreshDrawer(){
  return fetch('/cart.js',{headers:{Accept:'application/json'}})
  .then(function(r){return r.json();})
  .then(renderDrawer)
  .catch(function(){});
}
/* v6.18: run the kit reconciler the moment a mutation settles, rather than
   waiting for the 900ms reconcile poll. Removing one kit from a pair should
   drop the survivor to the Get The Kit price while the customer is still
   looking at the line. */
function kitReconcileNow(){
  return fetch('/cart.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json();})
    .then(fadReconcileKits)
    .then(function(c){if(drawerOpen)renderDrawer(c);return c;})
    .catch(function(){});
}
function updateCartBadge(count){
  qsa('#cart-count').forEach(function(el){
    el.textContent=count||'';
    el.style.display=count>0?'flex':'none';
  });
}
function initCartDrawer(){
  on(qs('#cart-toggle'),'click',function(){drawerOpen?closeDrawer():openDrawer();});
  on(qs('#cart-drawer-close'),'click',closeDrawer);
  on(qs('#cart-overlay'),'click',closeDrawer);
  on(document,'keydown',function(e){if(e.key==='Escape'&&drawerOpen)closeDrawer();});
  /* v5.30: key-based, queued, buttons locked while a mutation is in flight.
     Renders from the change.js response - no second round trip. */
  /* v5.70: variant picker on an upsell card retargets that card's add button
     and repaints its price, so what the button adds always matches what is shown. */
  /* ---- v5.76: MIXED FLAVOUR BUNDLE PICKER --------------------------- */

  /* expand / collapse a tier's flavour list */
  on(document,'click',function(e){
    var tg=e.target.closest('.cbundle__toggle');
    if(!tg)return;
    e.preventDefault();
    var box=tg.parentElement.querySelector('.cbundle__picker');
    if(!box)return;
    var open=box.hidden;
    box.hidden=!open;
    tg.setAttribute('aria-expanded',open?'true':'false');
    /* v6.41: the picker used to open below the fold. On a 390px phone two of
       the six flavours were on screen and the rest were a scroll the customer
       had no reason to know about. Pull the list up so the choice is the thing
       being looked at. */
    if(open){
      var body=qs('#cart-drawer-body');
      if(body){
        setTimeout(function(){
          try{
            var br=body.getBoundingClientRect(), tr=tg.getBoundingClientRect();
            body.scrollTo({top:body.scrollTop+(tr.top-br.top)-8,behavior:'smooth'});
          }catch(_){
            try{box.scrollIntoView({block:'nearest'});}catch(__){}
          }
        },60);
      }
    }
  });

  /* running total per tier, and the gate on the add button */
  function cbundleSync(block){
    var packs=parseInt(block.getAttribute('data-packs'),10)||0;
    var bid=block.getAttribute('data-bid');
    var tier=null;
    FAD_CORE_BUNDLES.tiers.forEach(function(t){ if(t.bid===bid)tier=t; });
    var n=0;
    [].forEach.call(block.querySelectorAll('.cbundle__n'),function(el){
      n+=parseInt(el.textContent,10)||0;
    });
    var cnt=block.querySelector('.cbundle__count');
    var add=block.querySelector('.cbundle__add');
    var fill=block.querySelector('.cbundle__progress-fill');
    if(fill)fill.style.width=(packs?Math.min(100,Math.round(n/packs*100)):0)+'%';
    block.classList.toggle('is-full',n===packs&&packs>0);
    /* ---- v6.37 WORDING --------------------------------------------------
       The old strings named the shortfall and then named the thing the button
       would not do: "0 of 6 chosen" beside a dead button reading "Add bundle".
       Both now tell the customer what to do next, and the moment the bundle is
       complete the button stops describing the task and starts quoting the
       price, which is the only thing left to agree to. */
    /* the counter reports progress, the button names the next action. v6.37's
       first pass had both saying "3 more", which is two controls repeating
       each other, the same fault as the old ADD pill. */
    if(cnt){
      if(n===0)cnt.textContent='Tap + to pick '+packs+' packs';
      else if(n===packs&&packs>0)cnt.textContent='Ready to add';
      else cnt.textContent=n+' of '+packs+' chosen';
    }
    if(add){
      add.disabled=(n!==packs);
      if(n===packs&&packs>0&&tier){
        /* v6.38: was "Add 6 Cores for $38.99". The last thing a thumb reads
           before it commits should be the win, not the bill. */
        add.textContent=(packs===6?'Add six and save ':'Add '+packs+' and save ')+tier.save+'%';
      }else if(n===0){
        /* v6.41: this said "Choose 6 flavours" directly underneath a toggle
           reading "Choose your 6 flavours". Two full width buttons, stacked,
           near enough word for word, one of them dead. */
        add.textContent='Pick your packs below';
      }else{
        add.textContent=(packs-n)+' pack'+((packs-n)===1?'':'s')+' to go';
      }
    }
    /* stop the pluses once the bundle is full, so nobody builds a seven
       flavour six pack and gets an error at the end instead of at the click */
    [].forEach.call(block.querySelectorAll('.cbundle__btn[data-step="1"]'),function(b){
      b.disabled=(n>=packs);
    });
    return n;
  }
  on(document,'click',function(e){
    var step=e.target.closest('.cbundle__btn');
    if(!step||step.disabled)return;
    e.preventDefault();
    var block=step.closest('.cbundle');
    var row=step.closest('.cbundle__row');
    var el=row.querySelector('.cbundle__n');
    var packs=parseInt(block.getAttribute('data-packs'),10)||0;
    var cur=parseInt(el.textContent,10)||0;
    var d=parseInt(step.getAttribute('data-step'),10);
    var next=Math.max(0,cur+d);
    if(d>0){
      var total=0;
      [].forEach.call(block.querySelectorAll('.cbundle__n'),function(x){total+=parseInt(x.textContent,10)||0;});
      if(total>=packs)return;
    }
    el.textContent=String(next);
    row.classList.toggle('is-picked',next>0);
    cbundleSync(block);
  });

  /* Builds the exact multi-line payload the product page sends: one line per
     unit, all quantity 1, the first carrying the main stamp and the rest the
     collection-break partner stamp. Quantities are never merged into one line
     because the stamp, not the quantity, is what Kaching prices. */
  function cbundleBody(block,tier,v){
    var b=new URLSearchParams(),i=0;
    [].forEach.call(block.querySelectorAll('.cbundle__row'),function(row){
      var n=parseInt(row.querySelector('.cbundle__n').textContent,10)||0;
      var vid=row.getAttribute('data-vid'), pid=parseInt(row.getAttribute('data-pid'),10);
      for(var k=0;k<n;k++){
        b.append('items['+i+'][id]',String(vid));
        b.append('items['+i+'][quantity]','1');
        b.append('items['+i+'][properties][__kaching_bundles]',JSON.stringify(
          i===0
            ? {deal:FAD_CORE_BUNDLES.deal,pp:pid,main:true,v:v,id:FAD_CORE_BUNDLES.offerId,bid:tier.bid}
            : {id:FAD_CORE_BUNDLES.offerId,deal:FAD_CORE_BUNDLES.deal,v:v,collectionBreaksProduct:true}
        ));
        i++;
      }
    });
    return i?b:null;
  }

  /* Kaching stamps at add time and reprices a moment later, so the only honest
     test of whether a bundle actually applied is the money. Compares the cart
     total before and after against the tier's advertised price, polling while
     the app catches up. If it never prices, the lines we just added are pulled
     back out: six packs at full price is a worse outcome than no upsell. */
  function cbundleVerify(beforeTotal,tier,addedKeys,block,label){
    var tries=0;
    function check(){
      tries++;
      return fetch('/cart.js',{headers:{Accept:'application/json'}})
        .then(function(r){return r.json();})
        .then(function(cart){
          var delta=cart.total_price-beforeTotal;
          /* priced correctly, or at least discounted below full price */
          if(delta<=tier.price+50){
            if(drawerOpen)renderDrawer(cart);
            return true;
          }
          if(tries<6){
            return new Promise(function(res){setTimeout(res,1500);}).then(check);
          }
          /* never applied: remove exactly what we added, nothing else */
          return cbundleRollback(addedKeys).then(function(){
            if(block){
              var foot=block.querySelector('.cbundle__foot');
              if(foot&&!foot.querySelector('.cbundle__err')){
                var p=document.createElement('p');
                p.className='cbundle__err';
                p.textContent='Bundle price did not apply, so nothing was added. Open a Cores page and add it there.';
                foot.insertAdjacentElement('afterend',p);
              }
              var b=block.querySelector('.cbundle__add');
              if(b){
                b.textContent=label||'Add bundle';
                b.classList.remove('is-busy');
                b.disabled=false;
              }
            }
            return false;
          });
        })
        .catch(function(){return false;});
    }
    return check();
  }
  function cbundleRollback(keys){
    var chain=Promise.resolve();
    keys.forEach(function(k){
      chain=chain.then(function(){return cartChangeByKey(k,0).catch(function(){});});
    });
    return chain.then(function(){return refreshDrawer();});
  }

  on(document,'click',function(e){
    var add=e.target.closest('.cbundle__add');
    if(!add||add.disabled)return;
    e.preventDefault();
    if(cartBusy)return;
    var block=add.closest('.cbundle');
    var bid=block.getAttribute('data-bid');
    var tier=null;
    FAD_CORE_BUNDLES.tiers.forEach(function(t){ if(t.bid===bid)tier=t; });
    var v=coreBundleInstance(window.__fadLastCart);
    if(!tier||!v)return;
    var body=cbundleBody(block,tier,v);
    if(!body)return;
    /* v6.35: the button carries markup now (label left, struck compare and
       price right), so textContent round-tripping flattened it into one run of
       text on every add. Snapshot the markup instead. */
    var label=add.textContent;
    cartBusy=true;
    add.classList.add('is-busy');
    add.textContent='Adding...';
    add.disabled=true;
    var bdr=qs('#cart-drawer');
    if(bdr)bdr.classList.add('is-updating');
    var beforeTotal=(window.__fadLastCart&&window.__fadLastCart.total_price)||0;
    var addedKeys=[];
    var errEl=block.querySelector('.cbundle__err');
    if(errEl)errEl.remove();
    queueCartOp(function(){
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
        body:body
      })
      .then(function(r){
        if(!r.ok)return r.json().then(function(err){throw new Error(err.description||'Could not add');});
        return r.json();
      })
      .then(function(res){
        var lines=(res&&res.items)||[res];
        lines.forEach(function(l){ if(l&&l.key)addedKeys.push(l.key); });
        /* theme.js adds with a custom fetch and would otherwise publish
           nothing, so the storefront pixels never see the bundle. */
        try{
          if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){
            lines.forEach(function(l){
              window.Shopify.analytics.publish('product_added_to_cart',{cartLine:l});
            });
          }
        }catch(_){}
        return refreshDrawer().then(function(){
          return cbundleVerify(beforeTotal,tier,addedKeys,block,label);
        });
      })
      .catch(function(){
        add.textContent='Could not add';
        add.classList.remove('is-busy');
        add.disabled=false;
      })
      .then(function(){
        cartBusy=false;
        if(bdr)bdr.classList.remove('is-updating');
        if(add.classList.contains('is-busy')){add.textContent=label;add.classList.remove('is-busy');}
        scheduleCartReconcile(function(c){if(drawerOpen)renderDrawer(c);});
      });
    });
  });

  on(document,'click',function(e){
    var btn=e.target.closest('.drawer-qty-btn');
    var rem=e.target.closest('.drawer-item__remove')||e.target.closest('.drawer-bundle__rowremove');
    var brem=e.target.closest('.drawer-bundle__remove');
    if(!btn&&!rem&&!brem)return;
    if(cartBusy)return;
    if(brem){
      var bkeys=(brem.getAttribute('data-keys')||'').split(',').filter(Boolean);
      if(!bkeys.length)return;
      cartBusy=true;
      var bdrawer=qs('#cart-drawer');
      if(bdrawer)bdrawer.classList.add('is-updating');
      queueCartOp(function(){
        return cartRemoveKeys(bkeys)
          .then(renderDrawer)
          .catch(function(){return refreshDrawer();})
          .then(function(){
            cartBusy=false;
            if(bdrawer)bdrawer.classList.remove('is-updating');
            kitReconcileNow();
            scheduleCartReconcile(function(c){if(drawerOpen)renderDrawer(c);});
          });
      });
      return;
    }
    var key,newQty;
    if(btn){
      key=btn.getAttribute('data-key');
      var val=btn.closest('.drawer-item__qty').querySelector('.drawer-qty-val');
      var cur=parseInt(val?val.textContent:1,10)||1;
      newQty=btn.getAttribute('data-action')==='dec'?Math.max(0,cur-1):cur+1;
      if(val)val.textContent=newQty;
    }else{
      key=rem.getAttribute('data-key');
      newQty=0;
    }
    if(!key)return;
    cartBusy=true;
    var drawer=qs('#cart-drawer');
    if(drawer)drawer.classList.add('is-updating');
    queueCartOp(function(){
      return cartChangeByKey(key,newQty)
        .then(renderDrawer)
        .catch(function(){return refreshDrawer();})
        .then(function(){
          cartBusy=false;
          if(drawer)drawer.classList.remove('is-updating');
          kitReconcileNow();
          /* v5.35: converge with Bundler's async regroup */
          scheduleCartReconcile(function(c){if(drawerOpen)renderDrawer(c);});
        });
    });
  });
}

/* ---- ADD TO CART (v5.41: bundle and subscription safe) ---------------
   ROOT CAUSE of missing bundle discounts.
   This function used to hand-build {id, quantity} JSON and POST it to
   /cart/add.js. Every other field in the product form was silently
   discarded, including the hidden inputs Kaching Bundles injects to tag a
   bundle selection and the selling_plan Kaching Subscriptions injects.
   The Shopify discount Function matches on those tags. Result: the cart
   received the correct QUANTITY at full price, with no discount attached.
   The v5.30 note below was a partial fix. It got quantity right and
   concluded the job was done.

   Fix is two layers.
   1. Give the app first refusal. Dispatch a real cancelable submit on the
      product form. If a listener calls preventDefault, the app owns the
      add and the theme does nothing further. This is the documented
      integration path, and it is what the old type="submit" button used to
      trigger. The "double add" that made someone switch to type="button"
      was the app adding correctly AND the theme adding again on top, not a
      browser fault.
   2. If nothing claims the submit, serialise the WHOLE form and post that,
      so any hidden input the app injected still travels with the request.
   The old id+quantity payload survives only as a fallback for quick-add
   buttons on product cards, which have no form around them. */

function atcFormBody(form,variantId,qty){
  var params=new URLSearchParams();
  var hasItemsArray=false;
  var fd=new FormData(form);
  fd.forEach(function(v,k){
    if(typeof v!=='string')return;
    if(k.indexOf('items[')===0)hasItemsArray=true;
    params.append(k,v);
  });
  /* A multi-product bundle posts items[n][id]. The theme's own hidden
     name=id and name=quantity inputs are still sitting in the form, and
     sending both shapes in one request is ambiguous to /cart/add.js.
     items[] wins, the single-line fields go. */
  if(hasItemsArray){
    params.delete('id');
    params.delete('quantity');
  } else {
    /* data-variant on the button is the live selection. The form's hidden
       name=id input is only correct on first paint (see initVariants, which
       now keeps it in sync). Trust the button, fall back to the form. */
    if(variantId)params.set('id',String(variantId));
    var formQty=parseInt(params.get('quantity'),10)||0;
    var wantQty=parseInt(qty,10)||0;
    if(wantQty>formQty)params.set('quantity',String(wantQty));
    if(!params.get('quantity'))params.set('quantity','1');
  }
  return params;
}

/* ---- v5.44: INTERCEPT AND REPLAY -------------------------------
   History, because the failure modes here are not obvious.

   v5.41 dispatched a submit and stood down when the app called
   preventDefault. Discount correct, but the page hard-navigated to /cart
   and the drawer died. Cause: the app finishes with form.submit(), which
   is a real browser POST. A synthetic submit event never navigates by
   itself.

   v5.42 sealed the window and additionally hung a CAPTURE-phase
   preventDefault on the form. That was the mistake. Capture runs before
   the app's own listener, so the app saw event.defaultPrevented already
   true and bailed out assuming another handler owned the add. It never
   injected its extra line items, and a multi-product bundle collapsed to
   one line. The guard was redundant: neutering the two native submit
   methods is what actually stops the navigation.

   v5.43 removed that guard. Items came back, and so did the redirect,
   which proved the navigation was never form.submit(). The app runs its
   own AJAX add and then sets location.href. That cannot be blocked.

   v5.44 stops trying to block the redirect and removes its trigger
   instead. During the window the app's own add request is captured and
   held: it is handed a promise that never settles, so the .then that
   performs the redirect never runs. The theme then replays the captured
   payload with the real transport. The app's exact bundle payload
   reaches the cart, none of its navigation does.

   What the sealed window does:
     - the app's /cart/add request is captured and held, then replayed by
       the theme after the window closes.
     - form.submit, form.requestSubmit and window.open neutered, plus a
       capture-phase guard on newly injected anchors. Every navigation
       vector reachable from JavaScript is closed.
     - NO preventDefault before the app runs. The event reaches the app
       pristine, so it injects its items[] and properties[] as designed.
     - both fetch and XMLHttpRequest are covered, since apps use either.
     - MutationObserver on the form. Apps inject their inputs
       asynchronously; the window extends after the last injection so we
       never serialise a half-built form.
     - Inputs injected during the window are removed once the add
       completes. The page reload used to wipe them. It no longer happens,
       so stale bundle markers would otherwise ride along on the next add
       and mis-price a plain single item.

   Residual limit: an app that fires location.href WITHOUT waiting on its
   own request would still navigate, because location is unforgeable. Held
   requests remove the wait, which is what makes this work in practice. */
var ATC_PROBE_MS=260;      /* floor: how long the app gets to react */
var ATC_SETTLE_MS=180;     /* extra grace after the last input injection */
var ATC_PROBE_MAX_MS=900;  /* hard ceiling so a broken app cannot hang ATC */
window.fadATCDebug=false;

function atcSend(form,variantId,qty){
  if(form){
    /* Do not set Content-Type. URLSearchParams sets
       application/x-www-form-urlencoded automatically, which is what
       /cart/add.js expects for properties[...] and items[n][...] keys. */
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:atcFormBody(form,variantId,qty)
    });
  }
  /* v6.18: a quick-add tile has no Kaching widget behind it, so a kit added
     from a collection card, a related-products card or search used to arrive
     unstamped and was charged full RRP. Verified live: $129.00 unstamped
     against $109.00 stamped. Stamping here saves the round trip the cart
     reconciler would otherwise spend fixing it a moment later.
     `pp` comes from data-product on the tile; without it the reconciler still
     catches the line, just one request later. */
  var payload={id:variantId,quantity:qty||1};
  if(atcKitStamp){
    payload.properties={__kaching_bundles:JSON.stringify(atcKitStamp)};
    atcKitStamp=null;
  }
  return fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(payload)
  });
}
/* Set by the tile click handler immediately before doATC, consumed once. */
var atcKitStamp=null;

function atcAfterAdd(restore){
  restore();
  openDrawer();
  /* v5.57: kick the QWF swap off the moment the add resolves. Waiting for the
     first reconcile poll cost a flat 900ms during which the drawer showed the
     undiscounted total. */
  fetch('/cart.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){
      if(drawerOpen)renderDrawer(c);
      return fadMaybeUpgradeQWF(c);
    })
    .then(function(c){if(drawerOpen)renderDrawer(c);})
    .catch(function(){});
  /* v5.35: poll until Bundler's discount lands, show pending indicator. */
  scheduleCartReconcile(function(c){if(drawerOpen)renderDrawer(c);});
}

function doATC(variantId,qty,btn,form,done){
  if(!variantId&&!form)return;
  var origText=btn?btn.textContent:'';
  /* v5.52: the buy box renders two ATC buttons. doATC monkey-patches window.fetch
     for the duration of the add, so two overlapping adds would re-patch fetch while
     the first is still in flight and could leave it patched. Lock every buy-box ATC
     button while one add is running, and unlock them together. */
  var peers=btn?qsa('.product-info .atc-btn').filter(function(b){return b!==btn;}):[];
  var peerWas=peers.map(function(b){return b.disabled;});
  var unlockPeers=function(){peers.forEach(function(b,i){b.disabled=peerWas[i];});};
  var restore=function(){if(btn){btn.disabled=false;btn.textContent=origText;}unlockPeers();};
  /* done lets Buy Now reuse this whole pipeline and redirect to checkout
     instead of opening the drawer. */
  var finish=done||function(){atcAfterAdd(restore);};
  if(btn){btn.disabled=true;btn.textContent='Adding...';}
  peers.forEach(function(b){b.disabled=true;});

  if(!form){
    atcSend(null,variantId,qty).then(atcCheck).then(finish).catch(function(){atcFail(btn,origText);unlockPeers();});
    return;
  }

  /* v5.44: INTERCEPT AND REPLAY.
     The app is not navigating via form.submit(). It runs its own AJAX add
     and then redirects, and a redirect written as location.href cannot be
     blocked by any theme code in any browser. So do not let its request
     complete. Hold the request, hand back a promise that never settles,
     and the .then that performs the redirect never runs. We then replay
     the app's own captured payload ourselves and open the drawer. The
     customer gets the app's exact bundle payload with none of its
     navigation. */
  var captured=[];
  var origFetch=window.fetch;
  var hasXhr=!!(window.XMLHttpRequest&&window.XMLHttpRequest.prototype);
  var XP=hasXhr?window.XMLHttpRequest.prototype:null;
  var origXhrOpen=XP?XP.open:null;
  var origXhrSend=XP?XP.send:null;
  var origXhrHeader=XP?XP.setRequestHeader:null;
  var origSubmit=HTMLFormElement.prototype.submit;
  var origRequestSubmit=HTMLFormElement.prototype.requestSubmit;
  var origOpen=window.open;
  var sealed=true;
  var settled=false;
  var vectors=[];

  /* Snapshot every field present before the app touches the form, so the
     ones it injects can be identified and removed afterwards. */
  var before=[];
  qsa('input,select,textarea',form).forEach(function(el){before.push(el);});
  function injectedFields(){
    return qsa('input,select,textarea',form).filter(function(el){return before.indexOf(el)<0;});
  }

  function isAddUrl(u){
    var s=(typeof u==='string')?u:((u&&u.url)||'');
    return String(s).indexOf('/cart/add')>=0;
  }
  var HOLD=function(){return new Promise(function(){});};

  /* fetch: capture and hold */
  window.fetch=function(u,init){
    if(sealed&&isAddUrl(u)){
      captured.push({kind:'fetch',args:[u,init]});
      vectors.push('fetch');
      return HOLD();
    }
    return origFetch.apply(this,arguments);
  };

  /* XHR: capture and swallow, so no readystate handler fires */
  if(XP){
    XP.open=function(m,u){
      this.__fadAdd=isAddUrl(u)?String(u):null;
      this.__fadMethod=m||'POST';
      this.__fadHeaders={};
      return origXhrOpen.apply(this,arguments);
    };
    XP.setRequestHeader=function(k,v){
      if(this.__fadAdd&&this.__fadHeaders)this.__fadHeaders[k]=v;
      return origXhrHeader.apply(this,arguments);
    };
    XP.send=function(body){
      if(sealed&&this.__fadAdd){
        captured.push({kind:'xhr',url:this.__fadAdd,method:this.__fadMethod,body:body,headers:this.__fadHeaders});
        vectors.push('xhr');
        return;
      }
      return origXhrSend.apply(this,arguments);
    };
  }

  /* Remaining navigation vectors we are able to close. */
  HTMLFormElement.prototype.submit=function(){vectors.push('form.submit');};
  if(origRequestSubmit)HTMLFormElement.prototype.requestSubmit=function(){vectors.push('form.requestSubmit');};
  window.open=function(){vectors.push('window.open');return null;};
  var linkGuard=function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
    if(!a)return;
    if(before.indexOf(a)>=0)return;
    vectors.push('a.click');
    e.preventDefault();
    e.stopPropagation();
  };
  document.addEventListener('click',linkGuard,true);

  function unseal(){
    if(!sealed)return;
    sealed=false;
    window.fetch=origFetch;
    if(XP){
      XP.open=origXhrOpen;
      XP.send=origXhrSend;
      XP.setRequestHeader=origXhrHeader;
    }
    HTMLFormElement.prototype.submit=origSubmit;
    if(origRequestSubmit)HTMLFormElement.prototype.requestSubmit=origRequestSubmit;
    window.open=origOpen;
    document.removeEventListener('click',linkGuard,true);
  }

  /* Replay whatever the app tried to send, using the real transport. */
  function replayCaptured(){
    return captured.reduce(function(chain,c){
      return chain.then(function(){
        if(c.kind==='fetch')return origFetch.apply(window,c.args);
        var h=c.headers||{};
        if(!h['Content-Type']&&!h['content-type'])h['Content-Type']='application/x-www-form-urlencoded';
        h.Accept=h.Accept||'application/json';
        return origFetch(c.url,{method:c.method||'POST',headers:h,body:c.body});
      }).then(function(r){
        /* A replayed payload can still be rejected (sold out, limits).
           Surface it on the button instead of opening an unchanged drawer. */
        if(r&&r.ok===false)throw new Error('replay rejected');
        return r;
      });
    },Promise.resolve());
  }

  /* Remove what the app injected, mirroring the page reload that used to
     clear it. Hidden inputs only, and nothing owned by the widget UI. */
  function cleanInjected(){
    var stripped=[];
    injectedFields().forEach(function(el){
      if(!el.name)return;
      if(el.tagName!=='INPUT'||String(el.type).toLowerCase()!=='hidden')return;
      if(el.closest&&el.closest('kaching-bundle,[data-bundle-slot]'))return;
      stripped.push(el.name);
      if(el.parentNode)el.parentNode.removeChild(el);
    });
    if(window.fadATCDebug&&stripped.length)console.log('[FAD ATC] stripped injected fields:',stripped);
  }

  /* Adaptive window. Apps inject asynchronously, so extend past the floor
     whenever the form changes, capped so a broken app cannot hang ATC. */
  var timer=null;
  var started=nowMs();
  var obs=null;
  function arm(ms){
    if(timer)clearTimeout(timer);
    var cap=ATC_PROBE_MAX_MS-(nowMs()-started);
    timer=setTimeout(settle,Math.max(0,Math.min(ms,cap)));
  }
  if(window.MutationObserver){
    obs=new MutationObserver(function(){
      if(settled)return;
      arm(ATC_SETTLE_MS);
    });
    obs.observe(form,{childList:true,subtree:true,attributes:true,attributeFilter:['value','name']});
  }

  function settle(){
    if(settled)return;
    settled=true;
    if(timer)clearTimeout(timer);
    if(obs)obs.disconnect();
    var held=captured.slice();
    unseal();
    if(window.fadATCDebug){
      console.log('[FAD ATC]',held.length?('replaying '+held.length+' app request(s)'):'theme built the payload',
        '| vectors blocked:',vectors,
        '| injected:',injectedFields().map(function(el){return el.name;}),
        '| window ms:',Math.round(nowMs()-started));
    }
    if(held.length){
      replayCaptured()
        .then(function(){cleanInjected();})
        .then(finish)
        .catch(function(){cleanInjected();atcFail(btn,origText);unlockPeers();});
      return;
    }
    atcSend(form,variantId,qty)
      .then(atcCheck)
      .then(function(r){cleanInjected();return r;})
      .then(finish)
      .catch(function(){cleanInjected();atcFail(btn,origText);unlockPeers();});
  }

  arm(ATC_PROBE_MS);
  try{form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));}
  catch(err){}
}

/* Exposed so the Buy Now button in product-main-fum.liquid runs the exact
   same handoff pipeline instead of carrying a second copy of it. */
window.fadAddToCart=function(variantId,qty,btn,form,done){return doATC(variantId,qty,btn,form,done);};

function atcFail(btn,origText){
  if(btn){btn.disabled=false;btn.textContent='Error - Try Again';setTimeout(function(){btn.textContent=origText;},3000);}
}

/* FIX v5.30: /cart/add.js returns 422 with a JSON error body (sold out,
   quantity limit). Previously that parsed fine and we opened the drawer as
   if the add succeeded. Treat non-ok as failure. */
function atcCheck(r){
  if(!r.ok)return r.json().then(function(err){throw new Error(err.description||'add failed');});
  return r.json();
}

function initATC(){
  on(document,'click',function(e){
    var btn=e.target.closest('.atc-btn,.pcard__quick-add');
    if(!btn||btn.disabled)return;
    e.preventDefault();
    var vid=btn.getAttribute('data-variant');
    var qty=1;
    /* FIX v5.30 (Bundler root cause): the form's name=quantity input
       (#qty-hidden) is the source of truth. Bundler writes its quantity
       break selection (e.g. Quit Together = 2) into the FORM input, not the
       visible #qty-input stepper. Reading only #qty-input sent quantity:1
       for bundle selections, so the 2-unit break never triggered and no
       discount applied. Quick-add buttons outside the product info column
       always add exactly 1 - they must not inherit the product page
       quantity (adding a carousel core with qty 3 selected added 3 cores). */
    var inProductInfo=!!btn.closest('.product-info')||btn.id==='atc-btn';
    /* v6.18: quick-add tiles carry data-handle and data-product so a kit can be
       stamped with the Get The Kit offer at add time. */
    atcKitStamp=null;
    if(!inProductInfo){
      var h=btn.getAttribute('data-handle')||'';
      var pid=parseInt(btn.getAttribute('data-product'),10)||0;
      if(pid&&FAD_KIT.kitHandles.indexOf(h)>=0){
        atcKitStamp={deal:FAD_KIT.deal,pp:pid,main:true,v:kitInstance([]),bid:FAD_KIT.single};
      }
    }
    /* v5.41: the product form is only used as the payload source for the
       main buy box. Quick-add tiles stay on the bare id+quantity path so
       they keep adding exactly 1 of their own variant. */
    var form=null;
    if(inProductInfo){
      var hid=qs('#qty-hidden');
      var vis=qs('#qty-input');
      var hv=hid?parseInt(hid.value,10)||0:0;
      var vv=vis?parseInt(vis.value,10)||0:0;
      qty=Math.max(hv,vv)||1;
      form=btn.closest('form[action*="/cart/add"]')||qs('#fad-product-form');
    }
    doATC(vid,qty,btn,form);
  });
  /* Mirror Bundler quantity-break selections into both quantity inputs so
     the customer sees the quantity that will actually be added. */
  on(document,'change',function(e){
    if(e.target&&e.target.name==='bundle_quantity'){
      var q=parseInt(e.target.value,10)||1;
      var inp=qs('#qty-input');
      var hid2=qs('#qty-hidden');
      if(inp)inp.value=q;
      if(hid2)hid2.value=q;
    }
  });
}

/* ---- PRODUCT GALLERY ---- */
function initGallery(){
  /* Thumb handling moved to initGalleryArrows for unified goTo with dots and transitions */
}

/* ---- VARIANT SELECTOR ---- */
function initVariants(){
  var vs=qs('#variant-select');
  if(!vs)return;
  var priceEl=qs('#prod-price');
  var stockEl=qs('#prod-stock');
  /* v5.52: the buy box now renders two ATC buttons (above and below the bundle
     widget). Both must track the selected variant; updating only #atc-btn left the
     top button with a stale data-variant and no Sold Out state. */
  var atcBtns=qsa('.product-info .atc-btn');
  var buyNow=qs('#buy-now-btn');

  function getSelectedVals(){
    var vals={};
    qsa('.variant-group').forEach(function(g){
      var idx=g.getAttribute('data-opt-idx');
      var sel=g.querySelector('.vbtn.is-selected');
      if(sel)vals[idx]=sel.getAttribute('data-val');
    });
    return vals;
  }
  function findVariant(vals){
    var opts=Object.values(vals);
    var found=null;
    qsa('option',vs).forEach(function(o){
      var parts=o.textContent.trim().split(' / ');
      if(opts.every(function(v,i){return parts[i]===v;}))found=o;
    });
    return found;
  }
  function applyVariant(opt){
    if(!opt)return;
    var price=parseInt(opt.getAttribute('data-price'),10);
    var compare=parseInt(opt.getAttribute('data-compare'),10);
    var avail=opt.getAttribute('data-avail')==='true';
    var stock=parseInt(opt.getAttribute('data-stock'),10);
    var vid=opt.value;
    vs.value=vid;
    if(priceEl){
      var h='';
      if(compare&&compare>price){
        var save=compare-price;
        h='<span class="price price--sale">'+formatMoney(price)+'</span>';
        h+='<span class="price price--compare">'+formatMoney(compare)+'</span>';
        h+='<span class="price-save-pill">Save '+formatMoney(save)+'</span>';
      }else{h='<span class="price">'+formatMoney(price)+'</span>';}
      priceEl.innerHTML=h;
    }
    if(stockEl){
      var lowStock=parseInt(stockEl.getAttribute('data-low-stock')||'5',10);
      var sb='';
      if(!avail)sb='<span class="stock-badge stock-badge--out">Out of stock</span>';
      else if(stock<=lowStock&&stock>0)sb='<span class="stock-badge stock-badge--low"><svg width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#e07b39"/></svg>Only '+stock+' left</span>';
      else sb='<span class="stock-badge stock-badge--in"><svg width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#28a745"/></svg>In stock, ships today</span>';
      stockEl.innerHTML=sb;
    }
    atcBtns.forEach(function(b){b.disabled=!avail;b.setAttribute('data-variant',vid);b.textContent=avail?(b.getAttribute('data-orig-text')||'Add to Cart'):'Sold Out';});
    if(buyNow){buyNow.setAttribute('data-variant',vid);}
    /* v5.41: the form's hidden name=id input was never updated on variant
       change. Nothing read it while ATC hand-built its own payload, so the
       staleness was invisible. It is not invisible to Kaching Bundles or
       Kaching Subscriptions, which read the form to decide which product
       the bundle applies to. Keep it in sync. */
    var vHidden=qs('#variant-input');
    if(vHidden){
      vHidden.value=vid;
      vHidden.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  on(document,'click',function(e){
    var btn=e.target.closest('.vbtn');
    if(!btn)return;
    var group=btn.closest('.variant-group');
    if(!group)return;
    qsa('.vbtn',group).forEach(function(b){b.classList.remove('is-selected');});
    btn.classList.add('is-selected');
    var idx=group.getAttribute('data-opt-idx');
    var labelVal=qs('#opt-val-'+idx);
    if(labelVal)labelVal.textContent=btn.getAttribute('data-val');
    var variant=findVariant(getSelectedVals());
    applyVariant(variant);
    /* FIX: swap gallery to variant's featured image */
    var varImg=btn.getAttribute('data-img');
    if(varImg){
      var slides=qsa('.pgallery-slide');
      var thumbs2=qsa('.pgthumb');
      var matched=-1;
      slides.forEach(function(s,i){
        var img=s.querySelector('img');
        if(img&&img.src&&img.src.split('?')[0]===varImg.split('?')[0])matched=i;
      });
      if(matched>-1){
        slides.forEach(function(s,i){s.classList.toggle('is-active',i===matched);});
        thumbs2.forEach(function(t,i){t.classList.toggle('is-active',i===matched);});
        if(thumbs2[matched])thumbs2[matched].scrollIntoView({block:'nearest',behavior:'smooth'});
      }
    }
  });
}

/* ---- QUANTITY CONTROLS ---- */
function initQty(){
  var inp=qs('#qty-input');
  var hidden=qs('#qty-hidden');
  function syncAll(val){
    val=Math.max(1,Math.min(99,val));
    if(inp)inp.value=val;
    if(hidden)hidden.value=val;
    /* v5.30: removed dead code that set an href on #buy-now-btn. It is a
       <button> (href has no effect) and /checkout?variant= is not a valid
       Shopify URL. Buy Now is handled by its own AJAX script in
       product-main-fum.liquid. */
  }
  on(document,'click',function(e){
    var btn=e.target.closest('.qty-btn');
    if(!btn||!inp)return;
    var v=parseInt(inp.value,10)||1;
    syncAll(btn.getAttribute('data-dir')==='1'?v+1:v-1);
  });
  if(inp)on(inp,'change',function(){syncAll(parseInt(inp.value,10)||1);});
}

/* ---- PRODUCT TABS ---- */
function initTabs(){
  var containers=document.querySelectorAll('.product-tabs');
  containers.forEach(function(container){
    var tabs=container.querySelectorAll('.product-tabs__tab');
    var panels=container.querySelectorAll('.product-tabs__panel');
    tabs.forEach(function(tab){
      on(tab,'click',function(){
        var targetId=tab.getAttribute('data-tab');
        tabs.forEach(function(t){t.classList.remove('is-active');t.setAttribute('aria-selected','false');});
        panels.forEach(function(p){p.classList.remove('is-active');hideEl(p);});
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected','true');
        var panel=document.getElementById('tab-panel-'+targetId)||container.querySelector('[data-panel="'+targetId+'"]');
        if(panel){panel.classList.add('is-active');showEl(panel);}
      });
    });
  });
}

/* ---- CART PAGE QTY ----
   v5.30: removed. The cart page renders and mutates its own items via the
   inline script in sections/cart-main-fum.liquid (key-based, queued). The
   old duplicate handler here was line-number based and its remove branch
   was unreachable dead code. ---- */

/* ---- TICKER PAUSE ON HOVER ---- */
function initTicker(){
  var track=qs('.ticker-bar__track');
  if(!track)return;
  on(track,'mouseenter',function(){qsa('.ticker-bar__inner').forEach(function(el){el.style.animationPlayState='paused';});});
  on(track,'mouseleave',function(){qsa('.ticker-bar__inner').forEach(function(el){el.style.animationPlayState='running';});});
}

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded',function(){
  initNav();
  initCartDrawer();
  initDiscountCode(); /* v6.34 */
  initATC();
  initGallery();
  initGalleryArrows();
  initVariants();
  initQty();
  initTabs();
  initAccordion();
  initTicker();
  initBuyBoxInline();
  qwfStashInstance();
  fetch('/cart.js',{headers:{Accept:'application/json'}})
  .then(function(r){return r.json();})
  .then(function(c){updateCartBadge(c.item_count);});
});

})();

/* ============================================================
   NAMED INIT FUNCTIONS
   All formerly-patched DOMContentLoaded blocks converted to
   named functions, called once from the single init handler.
   ============================================================ */

/* ── initGalleryArrows , prev/next, dots, touch swipe, keyboard ── */
function initGalleryArrows(){
  var gallery=document.getElementById('pgallery');
  var mainEl=document.getElementById('pgallery-main');
  if(!gallery||!mainEl)return;
  var slides=Array.from(gallery.querySelectorAll('.pgallery-slide'));
  var thumbs=Array.from(gallery.querySelectorAll('.pgthumb'));
  var total=slides.length;
  if(total<=1){gallery.classList.add('product-gallery--one');return;}

  var current=0;
  slides.forEach(function(s,i){if(s.classList.contains('is-active'))current=i;});

  // ── Build prev/next buttons ───────────────────────────────────
  function makeBtn(dir){
    var btn=document.createElement('button');
    btn.type='button';
    btn.className='pgallery-arrow pgallery-arrow--'+dir;
    btn.setAttribute('aria-label',dir==='prev'?'Previous image':'Next image');
    btn.innerHTML=dir==='prev'
      ?'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
      :'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    return btn;
  }
  var prevBtn=makeBtn('prev');
  var nextBtn=makeBtn('next');

  // ── Build dot indicators ──────────────────────────────────────
  var dotsWrap=document.createElement('div');
  dotsWrap.className='pgallery-dots';
  var dots=[];
  for(var d=0;d<total;d++){
    var dot=document.createElement('button');
    dot.type='button';
    dot.className='pgallery-dot'+(d===0?' is-active':'');
    dot.setAttribute('aria-label','Image '+(d+1)+' of '+total);
    dot.setAttribute('data-idx',String(d));
    dotsWrap.appendChild(dot);
    dots.push(dot);
  }

  // ── Build overlay arrows inside the main image ──────────────
  prevBtn.classList.add('pgallery-arrow--overlay','pgallery-arrow--overlay-prev');
  nextBtn.classList.add('pgallery-arrow--overlay','pgallery-arrow--overlay-next');
  mainEl.style.position='relative';
  mainEl.appendChild(prevBtn);
  mainEl.appendChild(nextBtn);

  // ── Build dots-only bar below image ──────────────────────────
  var ctrl=document.createElement('div');
  ctrl.className='pgallery-ctrl pgallery-ctrl--dots-only';
  ctrl.setAttribute('aria-hidden','true');
  ctrl.appendChild(dotsWrap);
  gallery.appendChild(ctrl);

  // ── Core goTo ─────────────────────────────────────────────────
  var track=document.getElementById('pgallery-track');
  function centerThumb(idx){
    if(!track||!thumbs[idx])return;
    // Translate the track so active thumb is centered in the filmstrip container
    var filmstrip=track.parentElement;
    var stripW=filmstrip.offsetWidth;
    var thumb=thumbs[idx];
    var thumbW=thumb.offsetWidth;
    var thumbGap=10;
    var totalThumbW=thumbW+thumbGap;
    // track has width:100% so track.scrollWidth === stripW even when the
    // thumbnails themselves take up less space , compute real content
    // width directly from the thumbnails instead.
    var contentW=(thumbs.length*thumbW)+((thumbs.length-1)*thumbGap);
    if(contentW<=stripW){
      // All thumbnails fit , centre the whole row evenly on both sides.
      var pad=(stripW-contentW)/2;
      track.style.transform='translateX('+pad+'px)';
      return;
    }
    var offset=(idx*totalThumbW)-(stripW/2)+(thumbW/2);
    offset=Math.max(0,Math.min(offset,contentW-stripW));
    track.style.transform='translateX(-'+offset+'px)';
  }
  function goTo(idx){
    idx=((idx%total)+total)%total;
    slides[current].classList.remove('is-active');
    if(thumbs[current])thumbs[current].classList.remove('is-active');
    if(dots[current])dots[current].classList.remove('is-active');
    current=idx;
    slides[current].classList.add('is-active');
    if(thumbs[current])thumbs[current].classList.add('is-active');
    if(dots[current])dots[current].classList.add('is-active');
    centerThumb(idx);
  }

  // Wire up overlay arrow buttons
  prevBtn.addEventListener('click',function(e){e.stopPropagation();goTo(current-1);});
  nextBtn.addEventListener('click',function(e){e.stopPropagation();goTo(current+1);});

  // Dot clicks
  dots.forEach(function(dot){
    dot.addEventListener('click',function(){goTo(parseInt(dot.getAttribute('data-idx'),10));});
  });

  // ── Thumbnail clicks ───────────────────────────────────────────
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){goTo(i);});});

  // ── Keyboard nav ──────────────────────────────────────────────
  document.addEventListener('keydown',function(e){
    if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
    var r=mainEl.getBoundingClientRect();
    if(r.bottom<0||r.top>window.innerHeight)return;
    e.preventDefault();
    goTo(e.key==='ArrowLeft'?current-1:current+1);
  });

  // ── Touch swipe with momentum feel ───────────────────────────
  var tx=0,ty=0,swiping=false;
  mainEl.addEventListener('touchstart',function(e){
    tx=e.touches[0].clientX;
    ty=e.touches[0].clientY;
    swiping=true;
  },{passive:true});
  mainEl.addEventListener('touchmove',function(e){
    if(!swiping)return;
    var dx=e.touches[0].clientX-tx;
    var dy=e.touches[0].clientY-ty;
    // Block vertical scroll hijack only when clearly horizontal
    if(Math.abs(dx)>Math.abs(dy)+8){e.preventDefault();}
  },{passive:false});
  mainEl.addEventListener('touchend',function(e){
    if(!swiping)return;
    swiping=false;
    var dx=tx-e.changedTouches[0].clientX;
    var dy=ty-e.changedTouches[0].clientY;
    if(Math.abs(dx)>32&&Math.abs(dx)>Math.abs(dy)){goTo(dx>0?current+1:current-1);}
  },{passive:true});

  // Centre the filmstrip on initial load (covers the "few thumbnails,
  // left-aligned instead of centred" case before any interaction).
  requestAnimationFrame(function(){centerThumb(current);});
  window.addEventListener('resize',function(){centerThumb(current);});
}

/* ── #atc-btn add-to-cart handled by initATC/doATC (single path) ── */

/* ── initAccordion , animated product accordion, aria, keyboard ── */
function initAccordion(){
  var acc=document.getElementById('product-accordion');
  if(!acc)return;
  var items=Array.from(acc.querySelectorAll('.pacc__item'));
  items.forEach(function(item){
    var body=item.querySelector('.pacc__body');
    if(!body)return;
    if(item.classList.contains('is-open')){
      body.removeAttribute('hidden');
      requestAnimationFrame(function(){
        body.style.maxHeight=body.scrollHeight+'px';
        body.style.visibility='visible';
      });
    }else{
      body.setAttribute('hidden','');
      body.style.maxHeight='0';
      body.style.visibility='hidden';
    }
  });
  function openItem(item){
    var body=item.querySelector('.pacc__body');
    var btn=item.querySelector('.pacc__trigger');
    if(!body||!btn)return;
    item.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    body.removeAttribute('hidden');
    body.style.visibility='visible';
    requestAnimationFrame(function(){body.style.maxHeight=body.scrollHeight+'px';});
  }
  function closeItem(item){
    var body=item.querySelector('.pacc__body');
    var btn=item.querySelector('.pacc__trigger');
    if(!body||!btn)return;
    item.classList.remove('is-open');
    btn.setAttribute('aria-expanded','false');
    body.style.maxHeight='0';
    body.addEventListener('transitionend',function hide(){
      body.removeEventListener('transitionend',hide);
      if(!item.classList.contains('is-open')){
        body.setAttribute('hidden','');
        body.style.visibility='hidden';
      }
    });
  }
  items.forEach(function(item){
    var btn=item.querySelector('.pacc__trigger');
    if(!btn)return;
    btn.addEventListener('click',function(){
      /* Lock trigger in viewport: capture position before changes, restore after */
      var _btnTop=btn.getBoundingClientRect().top;
      if(item.classList.contains('is-open')){
        closeItem(item);
      }else{
        items.forEach(function(other){
          if(other!==item&&other.classList.contains('is-open'))closeItem(other);
        });
        openItem(item);
      }
      requestAnimationFrame(function(){
        var delta=btn.getBoundingClientRect().top-_btnTop;
        if(Math.abs(delta)>2)window.scrollBy({top:delta,behavior:'instant'});
      });
    });
    btn.addEventListener('keydown',function(e){
      var triggers=items.map(function(i){return i.querySelector('.pacc__trigger');}).filter(Boolean);
      var idx=triggers.indexOf(btn);
      if(e.key==='ArrowDown'){e.preventDefault();(triggers[idx+1]||triggers[0]).focus();}
      else if(e.key==='ArrowUp'){e.preventDefault();(triggers[idx-1]||triggers[triggers.length-1]).focus();}
      else if(e.key==='Home'){e.preventDefault();triggers[0].focus();}
      else if(e.key==='End'){e.preventDefault();triggers[triggers.length-1].focus();}
    });
  });
}

/* ── Collection card tilt + shimmer effect (core-packs & full-collection) ── */
(function () {
  var handles = ['core-packs', 'full-collection'];
  handles.forEach(function(handle) {
  var section = document.querySelector('[data-collection="' + handle + '"]');
  if (!section) return;

  var isTouch = 'ontouchstart' in window;

  function pct(v, size) { return Math.max(0, Math.min(100, (v / size) * 100)).toFixed(1) + '%'; }

  /* Spawn a CSS ripple ring at touch point */
  function spawnRipple(media, cx, cy) {
    var ring = document.createElement('span');
    ring.className = 'cpcard-ring';
    ring.style.cssText = 'position:absolute;pointer-events:none;z-index:6;border-radius:50%;'
      + 'left:' + cx + '%;top:' + cy + '%;transform:translate(-50%,-50%) scale(0);'
      + 'width:120%;padding-bottom:120%;'
      + 'border:1.5px solid rgba(200,169,110,0.7);'
      + 'animation:cpring 0.65s cubic-bezier(0.23,1,0.32,1) forwards;';
    media.appendChild(ring);
    setTimeout(function () { ring.remove(); }, 700);
  }

  /* Inject ring keyframe once */
  if (!document.getElementById('cpring-kf')) {
    var s = document.createElement('style');
    s.id = 'cpring-kf';
    s.textContent = '@keyframes cpring{0%{transform:translate(-50%,-50%) scale(0);opacity:0.9}100%{transform:translate(-50%,-50%) scale(1);opacity:0}}';
    document.head.appendChild(s);
  }

  section.querySelectorAll('.pcard').forEach(function (card) {
    var media = card.querySelector('.pcard__media');
    if (!media) return;

    if (!isTouch) {
      /* ── Desktop: shimmer follows mouse, image zooms — no tilt
         (tilt on media container breaks overflow clip → hard edges) */
      card.addEventListener('mousemove', function (e) {
        var r = media.getBoundingClientRect();
        media.style.setProperty('--cx', pct(e.clientX - r.left, r.width));
        media.style.setProperty('--cy', pct(e.clientY - r.top, r.height));
        card.classList.add('is-active');
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-active');
      });

    } else {
      /* ── Mobile: spring-bounce + gold ring ripple ─────────── */
      card.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        var r = media.getBoundingClientRect();
        var cx = ((t.clientX - r.left) / r.width * 100).toFixed(1);
        var cy = ((t.clientY - r.top) / r.height * 100).toFixed(1);
        media.style.setProperty('--cx', cx + '%');
        media.style.setProperty('--cy', cy + '%');
        card.classList.add('is-active');
        spawnRipple(media, cx, cy);
        clearTimeout(card._ct);
        card._ct = setTimeout(function () {
          card.classList.remove('is-active');
        }, 800);
      }, { passive: true });
    }
  }); // end querySelectorAll forEach
  }); // end forEach handle
})();